import React from "react";
import { useState, useEffect, useReducer, useRef } from "react";
import Select from "react-select";
import "antd/dist/antd.css";
import "../NewDashboard/styles-for-new-dashboard.css";
import googleDomainsForSelector from "../FreeSerpChecker/google-domains2.json";
import { Input, Checkbox } from "antd";
import { v4 as uuidv4 } from "uuid";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Radio } from "antd";
import {
  InformationCircleIcon,
  ArrowDownIcon,
  ArrowUpIcon,
  ChevronRightIcon,
} from "@heroicons/react/20/solid";
import ApexCharts from "react-apexcharts";

import { Tooltip } from "recharts";

import { Alert, Table, Layout, Modal, message, Space } from "antd";
import { tooltip as tooltipBootstrap } from "react-bootstrap";
import { Form, Button, OverlayTrigger } from "react-bootstrap";
/* import { ColumnsType } from "antd/es/table"; */
import LoadingIndicator from "../SpinnerAndError/Loading";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  DeleteOutlined,
  OrderedListOutlined,
  FallOutlined,
  RiseOutlined,
  GlobalOutlined,
  CheckOutlined,
  SyncOutlined,
} from "@ant-design/icons";

import { Fragment } from "react";
import { Dialog, Menu, Transition } from "@headlessui/react";
import {
  Bars3BottomLeftIcon,
  ChartBarIcon,
  HomeIcon,
  XMarkIcon,
  PlusSmallIcon,
  ComputerDesktopIcon,
} from "@heroicons/react/24/outline";

import SmallSpinner from "../SpinnerAndError/SmallSpinner";
import moment from "moment";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function KeywordTrackingFromInsideApp() {
  const [isAveragePositionChartVisible, setIsAveragePositionChartVisible] =
    useState(true);

  const [
    loadingAverageWebsiteInformation,
    setLoadingAverageWebsiteInformation,
  ] = useState(false);

  const availableMetrics = [
    "averagePosition",
    "keywordsInTop3",
    "keywordsInTop10",
    "keywordsInTop30",
    "keywordsInTop100",
  ];
  const [activeMetricForAverageChartData, setActiveMetricForAverageChartData] =
    useState(null);
  const [chartDataForAverageChart, setChartDataForAverageChart] = useState([]);

  const [loadingSpecificKeywordGraphData, setLoadingSpecificKeywordGraphData] =
    useState(false);

  const [showDeleteSiteModal, setShowDeleteSiteModal] = useState(false);
  const [top100Data, setTop100Data] = useState([]);
  const [dataAvailableForTop100Modal, setDataAvailableForTop100Modal] =
    useState(true);
  const [websiteId, setWebsiteId] = useState("");
  const [graphData, setGraphData] = useState({});

  const [expandedRowKeys, setExpandedRowKeys] = useState([]);

  const [showMultiDeleteModal, setShowMultiDeleteModal] = useState(false);

  const [selectedRowsToDelete, setSelectedRowsToDelete] = useState(new Set());
  const [showModalNextButton, setShowModalNextButton] = useState(true);
  const [numKeywordsLeft, setNumKeywordsLeft] = useState(0);
  const [numKeywordsAdded, setNumKeywordsAdded] = useState(0);

  const [payingUser, setPayingUser] = useState(false);
  const [subscriptionType, setSubscriptionType] = useState(50);

  const [isCustomerPaying, setIsCustomerPaying] = useState(false);
  const [topKeywords, setTopKeywords] = useState(0);
  const [Link, setLink] = useState();
  const [visibleTheUniQueLinkModal, setVisibleTheUniQueLinkModal] =
    useState(false);
  const [selectedColumns, setSelectedColumns] = useState(["keyword"]);
  const [selectedColumnsForTheViewPage, setSelectedColumnsForTheViewPage] =
    useState([]);
  const [
    overallNumberOfKeywordsForAllSites,
    setOverallNumberOfKeywordsForAllSites,
  ] = useState(null);

  const [websiteDomainData, setWebsiteDomainData] = useState([]);
  const [featuredSnippet, setFeaturedSnippet] = useState(false);
  const [addedKeywordsFromModal, setAddedKeywordsFromModal] = useState([]);
  const [isModal1Open, setIsModal1Open] = useState(false);
  const [isModal2Open, setIsModal2Open] = useState(false);
  const [isModal3Open, setIsModal3Open] = useState(false);
  const [isModal4Open, setIsModal4Open] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [domainNameEntered, setDomainNameEntered] = useState("");
  const [urlDoesNotExist, setUrlDoesNotExist] = useState(false);
  const [keywordsFromModal, setKeywordsFromModal] = useState([]);
  const [browserTimedOut, setBrowserTimedOut] = useState(false);
  const [selectedMednuItem, setSelectedMenuItem] = useState("Keyword Tracker");
  const [errorInFetching, setErrorInFetching] = useState(false);
  const [newDataSourceForTheTable, setNewDataSourceForTheTable] = useState([]);

  const [show, setShow] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showTop100Modal, setShowTop100Modal] = useState(false);
  const [showTrendModal, setShowTrendModal] = useState(false);
  const [showChangeGoogleRegionModal, setShowChangeGoogleRegionModal] =
    useState(false);
  const [email, setEmail] = useState();
  const [usersWebsite, setUsersWebsite] = useState();
  const [loading, setLoading] = useState(false);
  const [overallLoading, setOverallLoading] = useState(false);
  const [overallLoadingWithWarningText, setOverallLoadingWithWarningText] =
    useState(false);
  const [editedKeywordsHasBeenChanged, setEditedKeywordsHasBeenChanged] =
    useState(false);
  const [editedKeywords, setEditedKeywords] = useState([]);
  const [inputChangeOnTheGo, setInputChangeOnTheGo] = useState("");
  const [country, setCountry] = useState("United States");
  const [googleDomain, setGoogleDomain] = useState("google.com");
  const [languageCode, setlanguageCode] = useState("en");
  const [countryCode, setCountryCode] = useState("us");
  const [device, setDevice] = useState("");
  const [
    arrayOfKeywordsWithAllInformation,
    setArrayOfKeywordsWithAllInformation,
  ] = useState([]);
  const [keyForTheTop100List, setKeyForTheTop100List] = useState(0);
  const [keyForTheTrendsList, setKeyForTheTrendsList] = useState(0);
  const [keywordSelected, setKeywordSelected] = useState("");
  /* const [domainNameEntered, setDomainNameEntered] = useState(""); */
  //THE BELOW ONES ARE USED FOR CHANGING THE GOOGLE REGION
  const [selectedGoogleDomain, setSelectedGoogleDomain] = useState();
  const [googleRegionsChosen, setGoogleRegionsChosen] = useState(false);
  const [deviceChosen, setDeviceChosen] = useState(false);
  const [firstTimeUser, setFirstTimeUser] = useState(false);

  //FOR THE NUMBER OF KEYWORDS - PAYING / NON PAYING USERS
  const [numberOfKeywordsExceeded, setNumberOfKeywordsExceeded] =
    useState(false);
  const [
    numberOfKeywordsExceededForPayingUser,
    setNumberOfKeywordsExceededForPayingUser,
  ] = useState(false); //THIS ONE ONLY GOES "TRUE" IF A PAYING USER HAS ADDED MORE THAN 100 KEYWORDS.
  //UNTIL HERE*****************

  //FOR THE SUMMARY CARDS
  const [averagePositionForKeywords, setAveragePositionForKeywords] =
    useState(0);
  const [
    yesterdaysAveragePositionForKeywords,
    setYesterdaysAveragePositionForKeywords,
  ] = useState(0);

  const [
    numberOfKeywordsThatHasImprovedSinceYesterday,
    setNumberOfKeywordsThatHasImprovedSinceYesterday,
  ] = useState(0);
  const [numberOfKeywordsInTop3, setNumberOfKeywordsInTop3] = useState(0);
  const [numberOfKeywordsInTop10, setNumberOfKeywordsInTop10] = useState(0);
  const [numberOfKeywordsInTop30, setNumberOfKeywordsInTop30] = useState(0);
  const [numberOfKeywordsInTop100, setNumberOfKeywordsInTop100] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop3,
    setYesterdaysNumberOfKeywordsInTop3,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop10,
    setYesterdaysNumberOfKeywordsInTop10,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop30,
    setYesterdaysNumberOfKeywordsInTop30,
  ] = useState(0);
  const [
    yesterdaysNumberOfKeywordsInTop100,
    setYesterdaysNumberOfKeywordsInTop100,
  ] = useState(0);

  //FOR THE DRAWER:
  const [visible, setVisible] = useState(false);

  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0); // NOT USING THIS ONE AT THE MOMENT. REACT WRITES THAT IT IS BEST NOT TO USE: https://reactjs.org/docs/hooks-faq.html
  const [reRender, setRerender] = useState(0);

  const location = useLocation();
  const params = new URLSearchParams(location.search);

  const specificWebsiteId = params.get("id"); // this is the ID that I take from the url.
  console.log("ID:", specificWebsiteId);

  const { Header, Content, Footer, Sider } = Layout;

  //THESE ARE THE TOKENS BELOW :
  const token = window.localStorage.getItem("token");
  const token2 = token?.slice(1, -1);

  const list = [FallOutlined];

  const navigation = [
    { name: "Dashboard", icon: HomeIcon, href: "/dashboard", current: false },
    {
      name: "Keyword tracker",
      icon: ChartBarIcon,
      href: "/keyword-tracker",
      current: true,
    },
    /* {
      name: "Bigboard",
      icon: UsersIcon,
      href: "/drag-and-drop-dashboard",
      current: false,
    }, */
    /*  {
      name: "Reports",
      icon: UsersIcon,
      href: "/saved-reports",
      current: false,
    }, */
    {
      name: "Meta-tag generator",
      icon: ComputerDesktopIcon,
      href: "/meta-checker",
      current: false,
    },
    /*  {
      name: "Schema Markup",
      icon: CodeBracketIcon,
      href: "/schema-generator",
      current: false,
    },   */
  ];

  const avatarOnClickFunction = (event) => {
    const eventName = event.target.innerText;

    if (eventName === "Sign out") {
      logoutFunction();
    }
  };

  const userNavigation = [
    { name: "Your Profile", href: "/profile" },
    /* { name: "Settings", href: "#" }, */
    { name: "Sign out", href: "#" },
  ];

  const secondaryNavigation = websiteDomainData?.map((data) => ({
    name: data.name,
    href: "/keyword-tracker" + "?" + "id=" + data.name,
    /* { name: "GraphQL API", href: "#" },
  { name: "Customer migration guides", href: "#" },
  { name: "Profit sharing program", href: "#" }, */
  }));

  console.log("SECONDARY", secondaryNavigation);

  useEffect(() => {
    // Wait until overallNumberOfKeywordsForAllSites has a non-null value
    if (overallNumberOfKeywordsForAllSites !== null) {
      const maxKeywords = getMaxKeywordsForSubscription();
      const keywordsLeft =
        maxKeywords - (overallNumberOfKeywordsForAllSites + numKeywordsAdded);
      setNumKeywordsLeft(keywordsLeft > 0 ? keywordsLeft : 0);
    }
  }, [overallNumberOfKeywordsForAllSites, numKeywordsAdded]);

  //THIS IS THE COMPONENT DID MOUNT****************************: (IT NOW INCLUDES THE "IGNORE" WHICH IS USED TO UPDATE COMPONENTS.)
  useEffect(() => {
    setNewDataSourceForTheTable([]); // JUST CLEARING THE KEYWORD TABLE ARRAY
    if (!token) {
      localStorage.clear();
      window.location.replace("/");
    }
    setOverallLoading(true); //TURNING ON LOADER HERE
    fetchDataOnMount();
  }, [reRender]);

  //THIS IS THE FETCH DATA FUNCTION, THAT IE BEING CALLED ON COMPONENT DID MOUNT: *************************
  const fetchDataOnMount = async () => {
    const bodyData = {
      url: specificWebsiteId,
    };

    console.log("Bodydata: ", bodyData);
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_EXISTING_KEYWORD_DATA,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();

        console.log("DATA ", data);

        setSubscriptionType(data.paymentInformation.subscriptionType);
        setOverallNumberOfKeywordsForAllSites(
          data.numberOfKeywordsBeingTracked
        );
        setFirstTimeUser(data.firstTimeUser);
        setPayingUser(data.paymentInformation.isCustomerPaying); // JUST A BOOLEAN - TRUE / FALSE
        setIsCustomerPaying(data.paymentInformation.isCustomerPaying); // JUST A BOOLEAN - TRUE / FALSE

        setWebsiteDomainData(data.allWebsiteInfo);
        setOverallLoading(false); // TURNING OFF LOADER HERE
        setEmail(data.email);
        setUsersWebsite(data.website.trackedUserDomain);
        setDevice(data.website.trackedDevice);
        setCountry(data.website.trackedCountry);
        setGoogleDomain(data.website.trackedGoogleDomain);
        setlanguageCode(data.website.trackedLanguageCode);
        setCountryCode(data.website.trackedCountryCode);
        setWebsiteId(data.website._id);
        const arrayOfKeywordsFromBackend = data?.keywords;
        console.log("ARRAY", arrayOfKeywordsFromBackend);

        const numberOfKeywordsToday = arrayOfKeywordsFromBackend
          ? arrayOfKeywordsFromBackend.length
          : 0;

        if (arrayOfKeywordsFromBackend) {
          setArrayOfKeywordsWithAllInformation(arrayOfKeywordsFromBackend);
        }

        let keywordPositionSumArray = [];
        let yesterdaysKeywordPositionSumArray = [];
        let numberOfImprovedKeywordsArray = [];
        let numberOfKeywordsBetween1And3Array = [];
        let numberOfKeywordsInTop10Array = [];
        let numberOfKeywordsInTop30Array = [];
        let numberOfKeywordsInTop100Array = [];
        let yesterdaysNumberOfKeywordsBetween1And3Array = [];
        let yesterdaysNumberOfKeywordsInTop10Array = [];
        let yesterdaysNumberOfKeywordsInTop30Array = [];
        let yesterdaysNumberOfKeywordsInTop100Array = [];

        //TEHRE IS SOME KIND OF BUG HERE:
        if (Object.keys(arrayOfKeywordsFromBackend).length > 0) {
          arrayOfKeywordsFromBackend.map((e, index) => {
            const lowestNumber = e.historicRankingsForThisKeyword.reduce(
              (a, b) => (a.rankingPosition < b.rankingPosition ? a : b),
              { rankingPosition: Infinity }
            );

            const firstTrackedPosition =
              e.historicRankingsForThisKeyword[0]?.rankingPosition; // THIS IS THE POSITION THAT WAS THE FIRST ONE WHEN KEYWORD WAS FIRST ADDED.
            const latest =
              e.historicRankingsForThisKeyword.slice(-1)[0]?.rankingPosition ||
              Infinity;
            // THIS IS GIVING BACK THE LAST ONE IN THE ARRAY

            const historicRankings = e.historicRankingsForThisKeyword;
            const previousToLatest =
              historicRankings.length <= 1
                ? "-"
                : historicRankings.slice(-2)[0]?.rankingPosition || Infinity;
            // THIS IS GIVING BACK THE SECOND LATEST POSITION IN THE ARRAY
            const change = latest - previousToLatest;
            console.log("change", change);
            if (change < 0) {
              //IF THE KEYWORD HAS IMPROVED IN RANKING (MEANING THAT IT IS MINUS) , THEN I PUSH "1" TO THE ARRAY
              numberOfImprovedKeywordsArray.push(1);
            }
            //THIS IS FOR CALCULATING THE AVERAGE POSITION
            if (Number.isInteger(e.currentRankingPosition))
              keywordPositionSumArray.push(e.currentRankingPosition);
            //THIS IS FOR CALCULATING YESTERDAYS AVERAGE POSITION
            if (Number.isInteger(previousToLatest))
              yesterdaysKeywordPositionSumArray.push(previousToLatest);

            //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (e.currentRankingPosition <= 3) {
              numberOfKeywordsBetween1And3Array.push(1);
            }
            if (e.currentRankingPosition <= 10) {
              numberOfKeywordsInTop10Array.push(1);
            }
            if (e.currentRankingPosition <= 30) {
              numberOfKeywordsInTop30Array.push(1);
            }
            if (e.currentRankingPosition <= 100) {
              numberOfKeywordsInTop100Array.push(1);
            }
            //BELOW I AM CALCULATING YESTERDAYS NUMBER OF KEYWORDS IN TOP3/10/30/100
            if (previousToLatest <= 3) {
              yesterdaysNumberOfKeywordsBetween1And3Array.push(1);
            }
            if (previousToLatest <= 10) {
              yesterdaysNumberOfKeywordsInTop10Array.push(1);
            }
            if (previousToLatest <= 30) {
              yesterdaysNumberOfKeywordsInTop30Array.push(1);
            }
            if (previousToLatest <= 100) {
              yesterdaysNumberOfKeywordsInTop100Array.push(1);
            }

            const best = lowestNumber?.rankingPosition || Infinity;
            const first = firstTrackedPosition || Infinity;
            const url_ranking = e.URLRanking || Infinity;

            const featuredSnippetDisplayedLink = e.allSerpInfoForKeyword?.link;

            const hasFeaturedSnippet = Boolean(featuredSnippetDisplayedLink);
            console.log("hasFeaturedSnippet:", hasFeaturedSnippet);
            if (hasFeaturedSnippet) {
              setFeaturedSnippet(true);
            }

            const last_updated =
              e.historicRankingsForThisKeyword[0]?.timestampForThisPosition ||
              Infinity;
            //These moment consts are used for calculating the time since last update , which is used in the table.
            const momentLastUpdated = moment(last_updated);
            const timeDifference = moment().diff(momentLastUpdated);
            const formattedLastUpdated =
              moment.duration(timeDifference).humanize() + " ago";

            const keywordNeedsToBeUpdated = e.keywordNeedsToBeUpdatedFirstTime;

            const volumeNeedsToBeUpdated =
              e.keywordVolumeNeedsToBeUpdatedFirstTime;

            const newDataRow = {
              key: index + 1,
              keyword: e.keyword,
              change: keywordNeedsToBeUpdated ? 0 : change || 0,
              latest: keywordNeedsToBeUpdated ? Infinity : latest || 0,
              yesterday: previousToLatest || 0,
              best: keywordNeedsToBeUpdated ? Infinity : best,
              first: keywordNeedsToBeUpdated ? Infinity : first,
              last_updated: keywordNeedsToBeUpdated
                ? Infinity
                : formattedLastUpdated,
              url_ranking: keywordNeedsToBeUpdated ? Infinity : url_ranking,
              volume: volumeNeedsToBeUpdated ? Infinity : e.keywordVolume || 0,
              competition: volumeNeedsToBeUpdated
                ? Infinity
                : e.keywordCompetition || 0,
              cpc: volumeNeedsToBeUpdated ? Infinity : e.keywordCpc || 0,
              action: "delete",
            };

            // If there's any additional data when keywordNeedsToBeUpdated is false
            if (!keywordNeedsToBeUpdated) {
              newDataRow.featured_snippet = featuredSnippetDisplayedLink;
            }

            setNewDataSourceForTheTable((data) => [...data, newDataRow]);
          });
          //BELOW HERE I AM DOING ALL THE CALCULATIONS FOR THE SUMMARY CARDS BASED ON THE ARRAYS I AM PUSHING INTO ABOVE

          //CALCULATING TODAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllCurrentPositions = keywordPositionSumArray.reduce(
            //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
            (partialSum, a) => partialSum + a,
            0
          );

          const averagePosition =
            sumOfAllCurrentPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

          const first4StrOfAveragePosition = String(averagePosition).slice(
            0,
            4
          ); // I ONLY WANT THE FIRST 4 NUMBERS (IN CASE IT IS A VERY LONG NUMBER)

          setAveragePositionForKeywords(first4StrOfAveragePosition);

          //CALCULATING YESTERDAYS TOTAL SUM OF KEYWORDS (ADDING THEM TOGETHER)
          const sumOfAllYesterdaysPositions =
            yesterdaysKeywordPositionSumArray.reduce(
              //I AM ADDING (PLUSSING) ALL POSITIONS TOGETHER.
              (partialSum, a) => partialSum + a,
              0
            );
          const yesterdaysAveragePosition =
            sumOfAllYesterdaysPositions / numberOfKeywordsToday; //GETTING THE AVERAGE POSITION BY DIVIDING THE SUM BY THE NUMBER OF KEYWORDS

          const first4StrOfYesterdaysAveragePosition = String(
            // I JUST NEED THE FIRST 4 STRINGS
            yesterdaysAveragePosition
          ).slice(0, 4);
          setYesterdaysAveragePositionForKeywords(
            first4StrOfYesterdaysAveragePosition
          );

          //BELOW I AM CALCULATING THE NUMBER OF KEYWORDS THAT HAVE IMPROVED SINCE THE DAY BEFORE.
          const numberOfKeywordsThatImproved =
            numberOfImprovedKeywordsArray.length;

          setNumberOfKeywordsThatHasImprovedSinceYesterday(
            numberOfKeywordsThatImproved
          );
          //BELOW I AM CALCULATING THE LENGTH OF THE "KEYWORDS IN TOP 3/10/30/100" ARRAYS
          //AND SETTING THEM IN STATE.
          const numberOfKeywordsInTop3 =
            numberOfKeywordsBetween1And3Array.length;
          const numberOfKeywordsInTop10 = numberOfKeywordsInTop10Array.length;
          const numberOfKeywordsInTop30 = numberOfKeywordsInTop30Array.length;
          const numberOfKeywordsInTop100 = numberOfKeywordsInTop100Array.length;

          setNumberOfKeywordsInTop3(numberOfKeywordsInTop3);
          setNumberOfKeywordsInTop10(numberOfKeywordsInTop10);
          setNumberOfKeywordsInTop30(numberOfKeywordsInTop30);
          setNumberOfKeywordsInTop100(numberOfKeywordsInTop100);

          //BELOW I AM CALCULATING THE LENGTH OF "YESTERDAYS KEYWORDS IN TOP 3/10/30/100" ARRAYS

          const yesterdaysNumberOfKeywordsInTop3 =
            yesterdaysNumberOfKeywordsBetween1And3Array.length;
          const yesterdaysNumberOfKeywordsInTop10 =
            yesterdaysNumberOfKeywordsInTop10Array.length;
          const yesterdaysNumberOfKeywordsInTop30 =
            yesterdaysNumberOfKeywordsInTop30Array.length;
          const yesterdaysNumberOfKeywordsInTop100 =
            yesterdaysNumberOfKeywordsInTop100Array.length;

          setYesterdaysNumberOfKeywordsInTop3(yesterdaysNumberOfKeywordsInTop3);
          setYesterdaysNumberOfKeywordsInTop10(
            yesterdaysNumberOfKeywordsInTop10
          );
          setYesterdaysNumberOfKeywordsInTop30(
            yesterdaysNumberOfKeywordsInTop30
          );
          setYesterdaysNumberOfKeywordsInTop100(
            yesterdaysNumberOfKeywordsInTop100
          );
        }
      } else if (response.status === 503) {
        const data = await response.json();

        setOverallLoading(false); // TURNING OFF LOADER HERE
        setFirstTimeUser(data.firstTimeUser);
        setIsCustomerPaying(data.paymentInformation.isCustomerPaying);
      } else if (response.status === 401) {
        console.log("Token not valid");
        window.location.replace("/login"); // I AM ADDING THIS ONE , SO THAT THE USER WILL BE REDIRECTED TO THE LOGIN PAGE IN CASE THE TOKEN IS EXPIRED.
      }
    } catch (error) {
      console.log(error);
    }
  };

  //ADD KEYWORDS MODAL -  OPEN AND CLOSE:
  const closeShowAddKeywordsModal = () => setShow(false);
  const showAddKeywordsModal = () => setShow(true);

  //CHANGE GOOGLE REGION MODAL -  OPEN AND CLOSE:
  const closeTheChangeGoogleRegionsModalFunction = () =>
    setShowChangeGoogleRegionModal(false);
  const showTheChangeGoogleRegionsModalFunction = () =>
    setShowChangeGoogleRegionModal(true);

  /*   **** THIS IS THE ONE THAT IS TRIGGERED WHEN ADDING MORE KEYWORDS AS A PAYING USER ***** */
  const submitMoreKeywordsFunction = (event) => {
    event.preventDefault();

    setLoading(true);
    saveAndAddedKeywordsForUserAndSaveInDatabase();
    closeShowAddKeywordsModal();
  };

  const pushEditedKeywordsToArrayFunction = (propertyName, targetValue) => {
    /* console.log("Target value", targetValue); */

    setEditedKeywordsHasBeenChanged(true);
    setEditedKeywords({
      ...editedKeywords,
      [propertyName]: targetValue,
    });
  };

  //THIS IS THE FETCH FOR ADDING MORE KEYWORDS ***********************************
  const saveAndAddedKeywordsForUserAndSaveInDatabase = async () => {
    console.log("specificWebsiteId", specificWebsiteId);
    console.log("usersWebsite", usersWebsite);

    const bodyDataForExtraKeywordsAdded = {
      website: specificWebsiteId !== null ? specificWebsiteId : usersWebsite,
      keywords: addedKeywordsFromModal,
      trackedUserDomain: usersWebsite,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    //I START BY CALCULATING THE NUMBER OF KEYWORDS THAT THE USER HAS
    // IF IT IS TOO MANY THEN I WILL JUST SHOW A MESSAGE OF SOME KIND.
    const numberOfExistingAndNewKeywords =
      addedKeywordsFromModal.length + arrayOfKeywordsWithAllInformation.length;

    if (numberOfExistingAndNewKeywords > 1 && isCustomerPaying === false) {
      setNumberOfKeywordsExceeded(true);
      setLoading(false);
      closeShowAddKeywordsModal();
    } else if (
      isCustomerPaying === true &&
      numberOfExistingAndNewKeywords > 100
    ) {
      setLoading(false);
      closeShowAddKeywordsModal();
      setNumberOfKeywordsExceededForPayingUser(true);
    } else {
      message.loading("keywords(s) are being added....", 5); // THIS IS THE LOADER ALERT IN THE TOP - WILL ONLY BE SHOWN IF THE USER IS "WITHIN THE LIMIT"
      try {
        const response = await fetch(
          process.env.REACT_APP_ADD_MORE_KEYWORDS_FOR_USER,
          {
            method: "POST",
            headers: {
              "Content-type": "application/json",
              Authorization: `Bearer ${token2}`,
            },
            body: JSON.stringify(bodyDataForExtraKeywordsAdded),
          }
        );
        if (response.status === 201) {
          const data = await response.json();
          setLoading(false);
          message.info({
            content:
              "Please update the page in 1-2 minutes to see the ranking positions of your keyword(s).",
            duration: 10, // Duration in seconds
            style: {
              fontSize: "1.2em",
              fontWeight: "700",
            },
          });

          closeShowAddKeywordsModal();
          /* typeaheadRef.current.clear(); */ // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
          setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
          setAddedKeywordsFromModal([]);
          setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
        }
      } catch (error) {
        console.log(error);
        setErrorInFetching(true);
        typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
        setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
      }
    }
  };

  //THESE BELOW ARE FOR THE GENERAL LAYOUT USING THE ANTD DESIGN:
  const onClick = ({ key }) => {
    message.info(`Click on item ${key}`);
    setSelectedMenuItem({ key });
  };

  const typeaheadRef = useRef(null); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE

  //THIS IS FOR THE CLOSING OF THE MODAL
  const handleOk = () => {
    setVisibleTheUniQueLinkModal(false);
    setShow(false);
    setShowDeleteModal(false);
    setNumberOfKeywordsExceeded(false);
    setNumberOfKeywordsExceededForPayingUser(false);
    setShowDeleteModal(false);
    setShowTop100Modal(false);
    setShowTrendModal(false);
    closeTheChangeGoogleRegionsModalFunction(false);
    typeaheadRef.current.clear(); // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
    setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
  };
  const handleCancel = () => {
    setVisibleTheUniQueLinkModal(false);
    setSelectedColumns([]);
    setShow(false);

    setShowDeleteModal(false);
    setShowTrendModal(false);
    setNumberOfKeywordsExceeded(false);
    setNumberOfKeywordsExceededForPayingUser(false);
    setShowTop100Modal(false);
    closeTheChangeGoogleRegionsModalFunction(false);
    /* typeaheadRef.current.clear(); */ // THIS IS USED FOR CLEARING THE INPUT FIELD IN THE "TYPEAHEAD" ON CLOSE
    setEditedKeywords([]); // THIS IS TO CLEAR WHAT WAS STORED IN THE STATE
  };

  const handleCancelModals = () => {
    setIsModal1Open(false);
    setIsModal2Open(false);
    setIsModal3Open(false);
    setIsModal4Open(false);
    setShowDeleteModal(false);
  };

  const handleOkModal = (index) => {
    setIsModal1Open(false);
    setShowDeleteModal(false);
  };

  // SIDER AND DRAWER TOGGLE
  const [isToggled, setToggled] = useState(false);
  const toggleTrueFalse = () => setToggled(!isToggled);
  const onClose = () => {
    setToggled(false);
  };

  const logoutFunction = () => {
    console.log("log me out please ");
    localStorage.clear();
    window.location.replace("/");
  };

  const menu = (
    <Menu
      onClick={logoutFunction}
      items={[
        /*         {
          label: "My account",
          key: "1",
        }, */
        /* {
          label: "Billing",
          key: "2",
        }, */
        {
          label: (
            <span style={{ color: "red" }} onClick={logoutFunction}>
              Logout
            </span>
          ),
          key: "3",
        },
      ]}
    />
  );
  function getItem(label, key, icon, children) {
    return {
      key,
      icon,
      children,
      label,
    };
  }

  //DRAFT TABLE DATA  (THIS ONE IS NOT BEING USED ANYMORE - CAN BE DELETED):

  /* const dataSource = [
    {
      key: "1",
      keyword: "Mike",
      position: 32,
      last_updated: "22-9-22",
      url_ranking: "google.com",
      action: "delete",
    },
    {
      key: "2",
      keyword: "John",
      position: 42,
      last_updated: "22-9-22",
      url_ranking: "google.com",
      action: "delete",
    },
  ]; */

  const updateKeywordFunction = async (event) => {
    const key = event.target.closest("tr").attributes[0].nodeValue;

    const keywordToUpdate = event.target
      .closest("tr")
      .childNodes.item(1).innerText;

    const bodyData = {
      key: key - 1,
      keywordToUpdate: keywordToUpdate,
      website: specificWebsiteId !== null ? specificWebsiteId : usersWebsite,
    };

    message.loading("keywords(s) are being updated....", 5); // THIS IS THE FIRST LOADER ALERT
    try {
      const response = await fetch(
        process.env.REACT_APP_UPDATE_REQUEST_FOR_SINGLE_KEYWORD,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();

        message.info({
          content:
            "Please update the page in 1-2 minutes to see your updated ranking positions.",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
        setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 400) {
        //THIS IS IN CASE THE USER IS NOT ALLOWED TO UPDATE THE KEYWORD RIGHT NOW BECAUSE HE/SHE HAS TO WAIT ONE HOUR
        message.error({
          content:
            "You can only update your keywords once every 12 hours. Please try again later.",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  const openUpTheDeleteMultipleRowsModal = () => {
    setShowMultiDeleteModal(true);
  };

  const deleteMultipleRowsInTableFunction = async () => {
    setShowMultiDeleteModal(false);

    /* const adjustedIndices = Array.from(selectedRowsToDelete).map(
      (index) => index - 1
    );  */
    const idsToDelete = Array.from(selectedRowsToDelete).map(
      (index) => arrayOfKeywordsWithAllInformation[index - 1]._id
    );

    const bodyData = {
      website: specificWebsiteId !== null ? specificWebsiteId : usersWebsite,
      keywordsToDelete: idsToDelete,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_DELETE_MULTIPLE_KEYWORDS_ENDPOINT,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setRerender([data]);
        setSelectedRowsToDelete(new Set()); // Clear selection after deletion
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  const allSelected =
    selectedRowsToDelete.size === newDataSourceForTheTable.length;

  const handleSelectAllRows = (e) => {
    if (e.target.checked) {
      const allRowKeys = newDataSourceForTheTable.map((row) => row.key);
      setSelectedRowsToDelete(new Set(allRowKeys));
    } else {
      setSelectedRowsToDelete(new Set());
    }
  };

  // THESE ARE THE COLUMNS USED FOR THE OVERALL!! TABLE *****************************
  const columns = [
    {
      /* title: "Keyword", */
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Keyword</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Your keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "keyword",
      key: "keyword",
      specialLabel: "The keywords",
      fixed: "left",
      width: 150,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Change</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Difference between yesterdays position and today's.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "change",
      key: "change",
      specialLabel: "Change from yesterday's position and today's",
      width: 70,
      render: (_, record) =>
        record.change < 0 ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.change === 0 ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
          /* (record, (<FallOutlined />)) */
          /* (record, (<RiseOutlined />)) */
        ),
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px", fontWeight: "bold" }}>
              Latest
            </span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The latest ranking position.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "latest",
      key: "latest",
      specialLabel: "Latest position",
      width: 70,
      render: (value) =>
        value === Infinity ? (
          <SmallSpinner />
        ) : (
          <span style={{ fontWeight: "bold" }}>{value}</span>
        ),
      sorter: (a, b) => a.latest - b.latest,
    },

    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Yesterday</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Yesterdays ranking position.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "yesterday",
      key: "yesterday",
      specialLabel: "Yesterday's position",
      width: 70,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
      sorter: (a, b) => a.yesterday - b.yesterday,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Best</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The highest position since starting to track keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },

      dataIndex: "best",
      key: "best",
      specialLabel: "Best position since start of tracking",
      width: 70,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
      sorter: (a, b) => a.best - b.best,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>First</span>{" "}
            <OverlayTrigger
              key="left"
              placement="bottom"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The position when the keyword was added.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "first",
      key: "first",
      specialLabel: "The first position when keyword was added",
      width: 70,

      sorter: (a, b) => a.first - b.first,
      render: (_, record) =>
        record.first === Infinity ? (
          <SmallSpinner />
        ) : record.first === "Not ranking in top 100" ? (
          _
        ) : record.first > record.latest ? (
          <span>
            {_}
            <RiseOutlined style={{ color: "green" }} />
          </span>
        ) : record.first === record.latest ? (
          _
        ) : (
          <span>
            {_}
            <FallOutlined style={{ color: "red" }} />
          </span>
        ),
    },
    /*  ...(featuredSnippet
      ? [
          {
            title: () => {
              return (
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span style={{ paddingRight: "2px" }}>
                    Featured snippet link
                  </span>{" "}
                  <OverlayTrigger
                    key="left"
                    placement="top"
                    overlay={
                      <tooltipBootstrap
                        id={`tooltip-${"left"}`}
                        style={{
                          background: "#E6F7FF",
                          maxWidth: "250px",
                          padding: "8px",
                          borderRadius: "4px",
                        }}
                      >
                        A featured snippet is a summary of an answer to a search
                        query that is displayed prominently at the top of the
                        search results page in what's called the "position zero"
                        or "rank zero" position.<br></br>
                        <br></br> In terms of SEO, getting your content featured
                        as a snippet can be highly valuable because it can
                        increase your website's visibility and click-through
                        rates.
                      </tooltipBootstrap>
                    }
                  >
                    <i
                      style={{ color: "#A5A5A5" }}
                      className="bi bi-info-circle"
                    ></i>
                  </OverlayTrigger>
                </div>
              );
            },
            dataIndex: "featured_snippet",
            key: "featured_snippet",
            specialLabel: "Show featured snippets",
            width: 100,
            render: (value) => {
              const contentStyle = { fontSize: "11px" };
              return value === Infinity ? (
                <SmallSpinner />
              ) : (
                <span style={contentStyle}>{value}</span>
              );
            },
          },
        ]
      : []), */

    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Volume</span>{" "}
            <OverlayTrigger
              key="top"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-top`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The estimated monthly search volume for this keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "volume",
      key: "volume",
      specialLabel: "Search Volume",
      width: 90,
      render: (value) =>
        value === Infinity ? (
          <SmallSpinner />
        ) : value === 0 ? (
          "-"
        ) : (
          value.toLocaleString()
        ),
    },

    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Competition</span>{" "}
            <OverlayTrigger
              key="top"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-top`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Competition level for this keyword is rated on a scale from 1
                  to 100, with 100 representing the highest level of
                  competition.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "competition",
      key: "competition",
      specialLabel: "Competition Level",
      width: 90,
      render: (value) =>
        value === Infinity ? <SmallSpinner /> : value === 0 ? "-" : value,
    },
    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>CPC</span>{" "}
            <OverlayTrigger
              key="top"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-top`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Cost Per Click (CPC) for this keyword, denominated in USD.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "cpc",
      key: "cpc",
      specialLabel: "Cost Per Click",
      width: 70,
      render: (value) =>
        value === Infinity ? <SmallSpinner /> : value === 0 ? "-" : value,
    },

    {
      title: "Last updated",
      dataIndex: "last_updated",
      specialLabel: "Last time keyword was updated",
      key: "last_updated",
      width: 100,
      render: (value) => (value === Infinity ? <SmallSpinner /> : value),
    },
    {
      title: () => {
        return (
          <div className="flex justify-between">
            <span className="pr-0.5">URL ranking</span>
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  The URL that is ranking for the keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      dataIndex: "url_ranking",
      key: "url_ranking",
      specialLabel: "Url that is ranking",
      width: 100,
      render: (value) => {
        return value === Infinity ? (
          <SmallSpinner />
        ) : (
          <span className="truncate-text">{value}</span>
        );
      },
    },

    {
      title: () => {
        return (
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ paddingRight: "2px" }}>Top domains</span>{" "}
            <OverlayTrigger
              key="left"
              placement="top"
              overlay={
                <tooltipBootstrap
                  id={`tooltip-${"left"}`}
                  style={{
                    background: "#E6F7FF",
                    maxWidth: "150px",
                    padding: "8px",
                    borderRadius: "4px",
                  }}
                >
                  Shows the top ranking domains for the keyword.
                </tooltipBootstrap>
              }
            >
              <i style={{ color: "#A5A5A5" }} className="bi bi-info-circle"></i>
            </OverlayTrigger>
          </div>
        );
      },
      /* dataIndex: "action", */
      key: "trend",
      width: 70,
      render: (_, record) => (
        <div style={{ display: "flex" }}>
          <Space size="middle" style={{ paddingRight: "2px" }}>
            <span
              onClick={openUpTheTop100Modal}
              className="show-top-domains-for-the-keyword "
            >
              <OrderedListOutlined />
            </span>
          </Space>
        </div>
      ),
    },
    {
      title: "Update keyword",
      /* dataIndex: "action", */
      key: "update",
      width: 70,
      render: (_, record) => (
        <Space size="middle">
          <span
            onClick={updateKeywordFunction}
            className="show-top-domains-for-the-keyword"
          >
            <SyncOutlined />
          </span>
        </Space>
      ),
    },
    {
      title: (
        <div>
          <Checkbox
            onChange={handleSelectAllRows}
            checked={allSelected}
            style={{ marginLeft: "10px", fontSize: "11px" }}
          >
            Select All
          </Checkbox>
          {selectedRowsToDelete.size > 0 && (
            <span
              onClick={openUpTheDeleteMultipleRowsModal}
              style={{
                marginLeft: "10px",
                color: "red",
                fontSize: "18px",
                cursor: "pointer",
              }}
            >
              <DeleteOutlined />
            </span>
          )}
        </div>
      ),
      key: "action",
      width: 60,
      render: (_, record) => (
        <Space size="middle">
          <Checkbox
            checked={selectedRowsToDelete.has(record.key)}
            onChange={(e) => {
              const newSelectedRowsToDelete = new Set(selectedRowsToDelete);
              if (e.target.checked) {
                newSelectedRowsToDelete.add(record.key);
              } else {
                newSelectedRowsToDelete.delete(record.key);
              }
              setSelectedRowsToDelete(newSelectedRowsToDelete);
            }}
          />
        </Space>
      ),
    },
  ];

  const fetchHistoricData = async (keyword) => {
    setLoadingSpecificKeywordGraphData(true);
    try {
      const bodyData = {
        keyword: keyword,
        websiteId: websiteId,
      };

      const response = await fetch(
        process.env.REACT_APP_GET_CHART_DATA_FOR_SPECIFIC_KEYWORD,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        // assuming data contains historicRankingsForThisKeyword
        setGraphData({ [keyword]: data.historicRankingsForThisKeyword });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingSpecificKeywordGraphData(false); // Ensure loading state is set to false in all cases
    }
  };

  let lastExpandedKey = null; // Outside your component to hold the last expanded key

  const onRowClick = (record) => {
    const key = record.key;
    const keyword = record.keyword;

    if (expandedRowKeys.includes(key)) {
      setExpandedRowKeys([]); // Close the current row if it is the same as the last expanded
      lastExpandedKey = null; // Reset last expanded key
    } else {
      if (lastExpandedKey !== null) {
        // Close the last expanded row if exists
        setExpandedRowKeys([key]);
      } else {
        // No row is expanded
        setExpandedRowKeys([key]);
      }
      fetchHistoricData(keyword); // Fetch data for the newly expanded row
      lastExpandedKey = key; // Update the last expanded key
    }
  };

  const expandedRowRender = (record) => {
    const keyword = record.keyword;
    const dataForThisKeyword = graphData[keyword] || [];

    if (loadingSpecificKeywordGraphData) {
      return (
        <div className="loaderContainer">
          <div className="keywordGraphLoader"></div>
        </div>
      );
    }

    if (dataForThisKeyword.length === 0) {
      return (
        <div className="noDataContainerForKeywordGraph">
          <span>No data available</span>
        </div>
      );
    }

    // Find the max value in the data
    const maxRanking = Math.max(
      ...dataForThisKeyword.map((item) => {
        return typeof item.rankingPosition === "number"
          ? item.rankingPosition
          : -Infinity;
      }),
      1 // Default to 1 if all values are null or 'Not ranking in top 100'
    );

    const formatDate = (isoString) => {
      const date = new Date(isoString);
      const day = date.getUTCDate();
      const month = date.getUTCMonth() + 1;
      const year = date.getUTCFullYear().toString().substr(2);
      return `${day}-${month}-${year}`;
    };

    const options = {
      chart: {
        id: "basic-bar",
      },
      xaxis: {
        categories: dataForThisKeyword.map((item) =>
          formatDate(item.timestampForThisPosition)
        ),
      },
      /* "comment" */
      yaxis: {
        min: 1,
        max: maxRanking + 2,
        labels: {
          formatter: (value) => {
            return parseFloat(value).toFixed(0);
          },
        },
      },
    };

    const series = [
      {
        name: "Position",
        data: dataForThisKeyword.map((item) => {
          return item.rankingPosition === "Not ranking in top 100"
            ? null
            : item.rankingPosition;
        }),
      },
    ];

    return <ApexCharts options={options} series={series} type="line" />;
  };

  //BELOW ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL:

  const customStylesWhenNotDisabled = {
    control: (base, state) => ({
      ...base,

      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  const options = googleDomainsForSelector.sort((a, b) => {
    if (a.value.country_name < b.value.country_name) {
      return -1;
    }
    if (a.value.country_name > b.value.country_name) {
      return 1;
    }
    return 0;
  });

  const onChangeForGoogleRegion = (event) => {
    /* console.log(event); */
    setGoogleRegionsChosen(true);
    setCountry(event.value.country_name);
    setGoogleDomain(event.value.domain);
    setCountryCode(event.value.country_code);
    setlanguageCode(event.value.language_code);
  };

  //FOR THE DEVICE INPUT FIELD
  const deviceOptions = [
    { value: "Desktop", label: "Desktop" },
    { value: "Mobile", label: "Mobile" },
    { value: "Tablet", label: "Tablet" },
  ];

  const onChangeOfDeviceHandler = (change) => {
    setDevice(change.value);
    setDeviceChosen(true);
  };

  const customStyles = {
    control: (base, state) => ({
      ...base,
      borderRadius: "4px",
      border: "1px solid #d9d9d9;",
      /* color: "black", */
      borderRadius: state.isFocused ? "4px" : "4px",
      height: "56px",
      fontColor: "#d9d9d9",
      /*       borderRadius: state.isFocused ? "3px 3px 0 0" : 3, */
      borderColor: state.isFocused ? "#28a745" : "#28a745",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "#28a745" : "#28a745",
      },
    }),
    menu: (base) => ({
      ...base,
      color: "black",
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      color: "black",
    }),
  };

  // ********** UNTIL HERE - ABOVE ARE ALL THE FUNCTIONS AND STYLES FOR THE "CHANGE GOOGLE REGION" MODAL **********

  const handleSubmitForChangingGoogleRegionAndDevice = async () => {
    setLoading(true);

    const bodyDataForChangingGoogleRegionAndDevice = {
      website: specificWebsiteId !== null ? specificWebsiteId : usersWebsite,
      trackedUserDomain: usersWebsite,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_EDIT_GOOGLE_REGION_AND_DEVICE_IN_USER_PROFILE,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyDataForChangingGoogleRegionAndDevice),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setLoading(false);
        closeTheChangeGoogleRegionsModalFunction(); // TO CLOSE THE MODAL
        setRerender([data]); // THIS IS JUST TO RE-RENDER THE COMPONENT
      } else if (response.status === 404) {
        setLoading(false);
        setErrorInFetching(true);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const takeMeToTheDashboardPage = () => {
    window.location.assign("/dashboard");
  };

  //BELOW IS THE FUNCTION WHEN CLICKING ON THE SHOW TREND BUTTON
  const openUpTheTrendModal = (event, index) => {
    event.preventDefault();
    setShowTrendModal(true);
    const key = event.target.closest("tr").attributes[0].nodeValue;
    setKeyForTheTrendsList(key - 1);
    const keyword = event.target.closest("tr").childNodes.item(0).innerText;

    setKeywordSelected(keyword);
  };

  //BELOW IS THE TABLE FOR THE TOP 100 WHEN CLICKING ON THE SHOW TOP 100 MODAL

  const fetchTop100Data = async (keyword) => {
    try {
      const response = await fetch(
        process.env.REACT_APP_FETCH_TOP_100_FOR_KEYWORD,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify({ keyword }),
        }
      );

      if (response.status === 404) {
        setDataAvailableForTop100Modal(false);
        return;
      }

      const data = await response.json();
      setTop100Data(data.top100Data);
      setDataAvailableForTop100Modal(true);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const openUpTheTop100Modal = (event, index) => {
    event.preventDefault();
    setShowTop100Modal(true);
    const key = event.target.closest("tr").attributes[0].nodeValue;
    setKeyForTheTop100List(key - 1);
    const keyword = event.target.closest("tr").childNodes.item(1).innerText;
    setKeywordSelected(keyword);

    // Fetch the data
    fetchTop100Data(keyword);
  };

  const columnsForTheTop100Table = [
    {
      title: "#",
      dataIndex: "position",
      key: "position",
      width: 20,
    },
    {
      title: "URL",
      dataIndex: "link",
      key: "link",
      width: 100,
      render: (text, record) => (
        <a target="_blank" href={text}>
          {text}
        </a>
      ),
    },
    /* {
      title: "URL",
      dataIndex: "url",
      key: "url",
      width: 100,
    }, */
  ];

  let navigate = useNavigate();

  const navigateToPricesPageFunction = () => {
    window.location.assign("https://serpmaze.com/#pricing");
  };

  //THIS IS THE MODAL INFORMATION:
  const showModal1 = () => {
    console.log("Loading before:", loading);
    setLoading(false);
    console.log("Loading after:", loading); // Keep i

    setIsModal1Open(true);
    setIsModal2Open(false);
  };

  const showModal2 = () => {
    setIsModal1Open(false);
    setIsModal3Open(false);
    setIsModal2Open(true);
    setIsModal4Open(false);
    setLoading(false);
  };

  const showModal3 = () => {
    setIsModal2Open(false);
    setIsModal4Open(false);
    setIsModal3Open(true);
  };
  const showModal4 = () => {
    setIsModal3Open(false);
    setIsModal2Open(false);
    setIsModal4Open(true);
  };

  const onChangeFunctionForUrlInput = (event) => {
    const result = event.target.value; /* .replace(
      /[!@#$%^&*()_+\=\[\]{};':"\\|,€<>\/?]+/,
      ""
    ); */
    setDomainNameEntered(result);
  };

  const handleSubmitForModal1 = (e) => {
    setUrlDoesNotExist(false);
    setErrorInFetching(false);
    e.preventDefault();
    setLoading(true);
    if (
      showModalNextButton === true &&
      domainNameEntered.length >= 4 &&
      !domainNameEntered.includes("@") &&
      !domainNameEntered.includes("!")
    ) {
      checkIfUrlExistsFunction();
    }
  };

  //THIS FUNCTION CHECK IF THE URL EXISTS IN MODAL 1 ***************************:
  const checkIfUrlExistsFunction = async () => {
    const bodyData = {
      url: domainNameEntered,
    };

    try {
      const response = await fetch(process.env.REACT_APP_CHECK_IF_URL_EXISTS, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token2}`,
        },
        body: JSON.stringify(bodyData),
      });
      if (response.status === 200) {
        console.log("url exists");
        setLoading(false);
        showModal2();
      } else if (response.status === 404) {
        console.log("Url does not exist");
        setUrlDoesNotExist(true);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };
  const handleSubmitForModal2 = (e) => {
    e.preventDefault();
    setLoading(true);
    if (deviceChosen === true && googleRegionsChosen === true) {
      saveGoogleRegionAndDeviceInUsersProfile();
    }
  };
  const saveGoogleRegionAndDeviceInUsersProfile = async () => {
    const bodyData = {
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_SET_GOOGLE_REGION_AND_DEVICE_IN_USER_PROFILE,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        console.log("data saved");
        setLoading(false);
        showModal4();
      } else if (response.status === 404) {
        setLoading(false);
        setErrorInFetching(true);
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setLoading(false);
      setErrorInFetching(true);
    }
  };

  const donwloadInformationAsCSVFunction = async () => {
    console.log("from fetch: ", specificWebsiteId);
    message.loading("Hang on. We are fetching your data....", 5);
    const bodyData = {
      url: specificWebsiteId,
    };
    try {
      const response = await fetch(
        process.env.REACT_APP_DOWNLOAD_KEYWORDDATA_AS_CSV,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.ok) {
        const csvData = await response.text();
        const blob = new Blob([csvData], { type: "text/csv" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "keyword-data.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        message.success({
          content: "Your keyword data has now been downloaded.",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      } else {
        message.error({
          content: "Something went wrong - please try again later.",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: "Something went wrong - please try again later.",
        duration: 10, // Duration in seconds
        style: {
          fontSize: "1.2em",
          fontWeight: "700",
        },
      });
    }
  };

  //THIS IS THE SHARE UNIQUE LINK FUNCTION - THAT CREATES A UNIQUE LINK TO SHARE
  const shareUniqueLinkFunction = async () => {
    console.log("from fetch: ", specificWebsiteId);
    message.loading("Hang on. We are creating your unique link....", 5);
    console.log("selected columns:", selectedColumns);
    const bodyData = {
      url: specificWebsiteId,
      columns: selectedColumns,
      topKeywords: topKeywords, // Adding topKeywords to the request body
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_CREATE_UNIQUE_SHAREBLE_LINK,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );

      if (response.ok) {
        const { link, selectedColumns } = await response.json();

        setLink(link);
        setSelectedColumnsForTheViewPage(selectedColumns);

        console.log("unique link: ", link);
        console.log("selected columns: ", selectedColumns);

        // Display the unique link to the user
        message.success({
          content: (
            <>
              Your unique link is:{" "}
              <a href={link} target="_blank">
                {link.length > 40 ? `${link.substring(0, 40)}...` : link}
              </a>
            </>
          ),
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      } else {
        message.error({
          content: "Something went wrong - please try again later.",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      }
    } catch (error) {
      console.log(error);
      message.error({
        content: "Something went wrong - please try again later.",
        duration: 10, // Duration in seconds
        style: {
          fontSize: "1.2em",
          fontWeight: "700",
        },
      });
    }
  };

  //THIS IS THE FUNCTION USED FOR THE 4TH MODAL FOR WHEN ADDING KEYWORDS
  const pushKeywordsFromModalFourToArrayFunction = (
    propertyName,
    targetValue
  ) => {
    setEditedKeywordsHasBeenChanged(true);
    setKeywordsFromModal({
      ...keywordsFromModal,
      [propertyName]: targetValue,
    });
  };

  //THIS IS TEH FUNCTION WHEN YOU CLICK THE "FINISH SETUP" BUTTON IN MODAL 4.
  const setupAllInformationAfterModal4Function = async () => {
    setLoading(true);

    message.loading("keywords(s) are being added....", 5); // THIS IS THE LOADER ALERT IN THE TOP - WILL ONLY BE SHOWN IF THE USER IS "WITHIN THE LIMIT"
    const bodyData = {
      domainUrl: domainNameEntered,
      email: email, //used to identify the user on the backend.
      keywords: addedKeywordsFromModal,
      trackedUserDomain: domainNameEntered,
      trackedDevice: device,
      trackedCountry: country,
      trackedGoogleDomain: googleDomain,
      trackedLanguageCode: languageCode,
      trackedCountryCode: countryCode,
    };
    try {
      const response = await fetch(
        process.env.REACT_APP_FINISH_SETUP_OF_NEW_USER,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 201) {
        const update = await response.json();
        setLoading(false);

        setIsModal1Open(false);
        setIsModal2Open(false);
        setIsModal3Open(false);
        setIsModal4Open(false);
        setDomainNameEntered("");
        setRerender([update]); // THIS IS JUST TO RE-RENDER THE COMPONENT
        window.location.href = "/dashboard";
        message.info({
          content:
            "Please update the page in 1-2 minutes to see the ranking positions of your keyword(s).",
          duration: 10, // Duration in seconds
          style: {
            fontSize: "1.2em",
            fontWeight: "700",
          },
        });
      } else if (response.status === 503) {
        setBrowserTimedOut(true);
        setOverallLoadingWithWarningText(false);
        setLoading(false);
        setIsModal1Open(false);
        setIsModal2Open(false);
        setIsModal3Open(false);
        setIsModal4Open(false);
        window.location.href = "/dashboard";
      }
    } catch (error) {
      console.log(error);
      console.log("something went wrong.");
      setOverallLoadingWithWarningText(false);
      setLoading(false);
      setErrorInFetching(true);
      setIsModal1Open(false);
      setIsModal2Open(false);
      setIsModal3Open(false);
      setIsModal4Open(false);
      window.location.href = "/dashboard";
    }
  };

  console.log("numKeywordsLeft", numKeywordsLeft);

  const onChangeForTheAddingOfMoreKeywords = (event) => {
    const value = event.target.value; // Get the textarea content
    let keywords = value.split("\n"); // Split by new lines

    // Trim each keyword and make it lowercase
    keywords = keywords.map((keyword) => keyword.trim().toLowerCase());

    // Filter out any empty keywords
    keywords = keywords.filter((keyword) => keyword.length > 0);
    updateNumKeywordsLeft(keywords);
    const nonEmptyKeywords = keywords.filter((str) => str !== "");
    setAddedKeywordsFromModal(nonEmptyKeywords);
  };

  const onChangeForModal4InputField = (event) => {
    const value = event.target.value; // Get the textarea content
    let keywords = value.split("\n"); // Split by new lines

    // Trim each keyword and make it lowercase
    keywords = keywords.map((keyword) => keyword.trim().toLowerCase());

    // Filter out any empty keywords
    keywords = keywords.filter((keyword) => keyword.length > 0);
    updateNumKeywordsLeft(keywords);
    const nonEmptyKeywords = keywords.filter((str) => str !== "");
    setAddedKeywordsFromModal(nonEmptyKeywords);
  };

  //BELOW ARE THE FUNCTION FOR THE SHARE UNIQUE LINK MODAL
  const handleModalOpen = () => {
    setVisibleTheUniQueLinkModal(true);
  };

  /*   const handleModalClose = () => {
    setVisibleTheUniQueLinkModal(false);
  }; */

  const handleCheckboxChange = (column, checked) => {
    if (checked) {
      setSelectedColumns([...selectedColumns, column]);
    } else {
      setSelectedColumns(selectedColumns.filter((c) => c !== column));
    }
  };

  const handleColumnSelect = (column, selected) => {
    setSelectedColumns((prevSelectedColumns) => {
      if (selected) {
        return prevSelectedColumns.filter((c) => c.key !== column.key);
      } else {
        return [...prevSelectedColumns, column];
      }
    });
  };

  const handleOkForUniqueLinkModal = (event) => {
    event.preventDefault();
    // Here, you can call an API to generate a unique link and send the selected columns as well
    // Once the API call is complete, you can redirect the user to the readonly view page
    shareUniqueLinkFunction();
    setSelectedColumns(["keyword"]);
    setVisibleTheUniQueLinkModal(false);
    setTopKeywords(0);
  };

  const handleCancelForUniqueLinkModal = () => {
    setSelectedColumns(["keyword"]);
    setTopKeywords(0);
    setVisibleTheUniQueLinkModal(false);
    /* handleModalClose(); */
  };

  const updateNumKeywordsLeft = (keywords) => {
    const maxKeywords = getMaxKeywordsForSubscription();
    console.log("Max Keywords:", maxKeywords);
    const numKeywords = keywords?.length || 0;
    console.log("numKeywords", numKeywords);
    const keywordsLeft =
      maxKeywords - (overallNumberOfKeywordsForAllSites + numKeywords);
    console.log(
      "overallNumberOfKeywordsForAllSites",
      overallNumberOfKeywordsForAllSites
    );
    console.log("keywordsLeft", keywordsLeft);
    setNumKeywordsLeft(keywordsLeft);
  };

  const getMaxKeywordsForSubscription = () => {
    return subscriptionType || 1;
  };

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }

  console.log("YTESTERDAY: ", yesterdaysAveragePositionForKeywords);

  const stats = [
    {
      name: "Average Position",
      stat: averagePositionForKeywords,
      previousStat:
        typeof yesterdaysAveragePositionForKeywords !== "undefined"
          ? yesterdaysAveragePositionForKeywords
          : 0,

      change: parseFloat(
        (
          averagePositionForKeywords - yesterdaysAveragePositionForKeywords
        ).toFixed(2)
      ),
      changeType:
        averagePositionForKeywords < yesterdaysAveragePositionForKeywords
          ? "increase"
          : averagePositionForKeywords === yesterdaysAveragePositionForKeywords
          ? "same"
          : "decrease",
    },
    {
      name: "Improved Keywords",
      stat: numberOfKeywordsThatHasImprovedSinceYesterday,
      previousStat: null,
      change: numberOfKeywordsThatHasImprovedSinceYesterday,
      changeType:
        numberOfKeywordsThatHasImprovedSinceYesterday > 0
          ? "increase"
          : numberOfKeywordsThatHasImprovedSinceYesterday === 0
          ? "same"
          : "decrease",
    },

    {
      name: "Keywords in Top 3",
      stat: numberOfKeywordsInTop3,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop3 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop3
          : 0,
      change: numberOfKeywordsInTop3 - yesterdaysNumberOfKeywordsInTop3,
      changeType:
        numberOfKeywordsInTop3 > yesterdaysNumberOfKeywordsInTop3
          ? "increase"
          : numberOfKeywordsInTop3 === yesterdaysNumberOfKeywordsInTop3
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 10",
      stat: numberOfKeywordsInTop10,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop10 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop10
          : 0,
      change: numberOfKeywordsInTop10 - yesterdaysNumberOfKeywordsInTop10,
      changeType:
        numberOfKeywordsInTop10 > yesterdaysNumberOfKeywordsInTop10
          ? "increase"
          : numberOfKeywordsInTop10 === yesterdaysNumberOfKeywordsInTop10
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 30",
      stat: numberOfKeywordsInTop30,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop30 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop30
          : 0,
      change: numberOfKeywordsInTop30 - yesterdaysNumberOfKeywordsInTop30,
      changeType:
        numberOfKeywordsInTop30 > yesterdaysNumberOfKeywordsInTop30
          ? "increase"
          : numberOfKeywordsInTop30 === yesterdaysNumberOfKeywordsInTop30
          ? "same"
          : "decrease",
    },
    {
      name: "Keywords in Top 100",
      stat: numberOfKeywordsInTop100,
      previousStat:
        typeof yesterdaysNumberOfKeywordsInTop100 !== "undefined"
          ? yesterdaysNumberOfKeywordsInTop100
          : 0,
      change: numberOfKeywordsInTop100 - yesterdaysNumberOfKeywordsInTop100,
      changeType:
        numberOfKeywordsInTop100 > yesterdaysNumberOfKeywordsInTop100
          ? "increase"
          : numberOfKeywordsInTop100 === yesterdaysNumberOfKeywordsInTop100
          ? "same"
          : "decrease",
    },
  ];

  const CustomAlert = ({ message }) => (
    <div className="rounded-md bg-blue-50 p-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <InformationCircleIcon
            className="h-5 w-5 text-blue-400"
            aria-hidden="true"
          />
        </div>
        <div className="ml-3 flex-1">
          <p className="text-sm text-blue-700 mb-0">{message}</p>
        </div>
      </div>
    </div>
  );

  const handleYesClick = async (event, index) => {
    setShowDeleteSiteModal(false);
    await removeSiteFunction(event, index); // Perform the delete operation
  };

  const handleNoClick = () => {
    setShowDeleteSiteModal(false); // Close the modal
  };

  const removeSiteFunction = async () => {
    const websiteIdToDelete = websiteId;

    const bodyData = {
      website: websiteIdToDelete,
    };
    try {
      const response = await fetch(
        process.env.REACT_APP_DELETE_A_SITE_FROM_DASHBOARD,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );
      if (response.status === 200) {
        const data = await response.json();
        setNewDataSourceForTheTable([]);
        setRerender([data]);
        takeMeToTheDashboardPage();
      }
    } catch (error) {
      console.log(error);
      setErrorInFetching(true);
    }
  };

  const fetchChartDataForAveragePositionChart = async (metric) => {
    setLoadingAverageWebsiteInformation(true); // Set loading to true when fetching starts

    setActiveMetricForAverageChartData(metric); // Set the currently active metric

    // Assuming you have the websiteId and token2 in the component's props or state
    const bodyData = {
      metric: metric,
      websiteId: websiteId,
    };

    try {
      const response = await fetch(
        process.env.REACT_APP_GET_CHART_DATA_FOR_AVERAGE_POSITION,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Authorization: `Bearer ${token2}`,
          },
          body: JSON.stringify(bodyData),
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        console.log("DATA:", data);

        // Update the chart data for the selected metric
        setChartDataForAverageChart(data.metricData);
      } else {
        // Handle non-success status codes
        console.error(`Error: Received status code ${response.status}`);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingAverageWebsiteInformation(false); // Set loading to false when fetching ends
    }
  };

  const renderChartButtonsForAveragePositionCharts = () => {
    const metrics = [
      { id: "averagePosition", name: "Average Position" },
      { id: "keywordsInTop3", name: "Keywords In Top 3" },
      { id: "keywordsInTop10", name: "Keywords In Top 10" },
      { id: "keywordsInTop30", name: "Keywords In Top 30" },
      { id: "keywordsInTop100", name: "Keywords In Top 100" },
    ];

    return metrics.map((metric) => (
      <button
        key={metric.id}
        onClick={() => {
          if (activeMetricForAverageChartData === metric.id) {
            // If the clicked button corresponds to the active metric, toggle the chart visibility
            setIsAveragePositionChartVisible(!isAveragePositionChartVisible);
          } else {
            // If the clicked button corresponds to a different metric, set the active metric
            setActiveMetricForAverageChartData(metric.id);
            // Always set the chart as visible when a new metric is selected
            setIsAveragePositionChartVisible(true);
            fetchChartDataForAveragePositionChart(metric.id);
          }
        }}
        className={`w-full lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md px-3.5 py-2.5 text-sm font-semibold ring-1 ring-inset ring-gray-300 ${
          activeMetricForAverageChartData === metric.id
            ? "bg-gray-200"
            : "bg-white hover:bg-gray-50"
        }`}
      >
        {metric.name}
      </button>
    ));
  };

  const renderChartForAveragePositionChart = () => {
    if (loadingAverageWebsiteInformation) {
      return (
        <div className="loaderContainer">
          <div className="keywordGraphLoader"></div>
        </div>
      );
    }
    if (!activeMetricForAverageChartData) {
      return <div>Please select a metric to display the chart</div>;
    }

    if (!chartDataForAverageChart || chartDataForAverageChart.length === 0) {
      return (
        <div className="noDataContainerForKeywordGraph">
          <div>No data available for {activeMetricForAverageChartData}</div>
        </div>
      );
    }

    // Find the max value in the data
    const maxRanking = Math.max(
      ...chartDataForAverageChart.map((item) => {
        return typeof item.value === "number" ? item.value : -Infinity;
      }),
      1 // Default to 1 if all values are null or 'Not ranking in top 100'
    );

    const isAveragePosition =
      activeMetricForAverageChartData === "averagePosition";

    const options = {
      chart: {
        id: "average-position-chart",
      },
      xaxis: {
        categories: chartDataForAverageChart.map((item) => item.timestamp),
      },
      yaxis: {
        min: 1,
        max: maxRanking + 2,
        labels: {
          formatter: (value) => {
            // If it is averagePosition metric, format the value to have one decimal
            if (isAveragePosition) {
              return parseFloat(value).toFixed(1);
            }
            // For other metrics, return the original value
            return parseFloat(value).toFixed(0); // It's a good practice to explicitly convert the value to string
          },
        },
      },
      // additional chart options based on your needs
    };

    const series = [
      {
        name: activeMetricForAverageChartData,
        data: chartDataForAverageChart.map((item) => item.value),
      },
    ];

    return <ApexCharts options={options} series={series} type="line" />;
  };

  return (
    <>
      {/*
        This example requires updating your template:

        ```
        <html class="h-full bg-gray-100">
        <body class="h-full">
        ```
      */}
      <div>
        <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog
            as="div"
            className="relative z-40 md:hidden"
            onClose={setSidebarOpen}
          >
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 z-40 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex h-10 w-10 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon
                          className="h-6 w-6 text-white"
                          aria-hidden="true"
                        />
                      </button>
                    </div>
                  </Transition.Child>
                  <div
                    style={{ cursor: "pointer" }}
                    className="flex flex-shrink-0 items-center px-4"
                  >
                    <img
                      className="h-12 w-auto"
                      src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                      alt="SerpMaze"
                      onClick={takeMeToTheDashboardPage}
                    />
                  </div>
                  <div className="mt-5 h-0 flex-1 overflow-y-auto">
                    <nav className="space-y-1 px-2">
                      {navigation.map((item) => (
                        <a
                          key={item.name}
                          href={item.href}
                          className={classNames(
                            item.current
                              ? "bg-gray-100 text-gray-900"
                              : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                            "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                          )}
                        >
                          <item.icon
                            className={classNames(
                              item.current
                                ? "text-gray-500"
                                : "text-gray-400 group-hover:text-gray-500",
                              "mr-3 flex-shrink-0 h-6 w-6"
                            )}
                            aria-hidden="true"
                          />
                          {item.name}
                        </a>
                      ))}
                      <div className="space-y-1 mt-5">
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "initial",
                            justifyContent: "space-between",
                            alignItems: "end",
                          }}
                        >
                          <h3
                            className="px-3 text-sm font-medium text-gray-500"
                            id="projects-headline"
                          >
                            Tracked sites
                          </h3>
                          <button
                            type="button"
                            className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            onClick={showModal1}
                            style={{ cursor: "pointer" }}
                          >
                            <PlusSmallIcon
                              className="h-4 w-4"
                              aria-hidden="true"
                            />
                          </button>
                        </div>
                        <div
                          className="space-y-1"
                          role="group"
                          aria-labelledby="projects-headline"
                        >
                          {secondaryNavigation?.map((item) => (
                            <a
                              key={item.name}
                              href={item.href}
                              className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                            >
                              <span className="truncate">{item.name}</span>
                            </a>
                          ))}
                        </div>
                      </div>
                    </nav>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="w-14 flex-shrink-0" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        {/* Static sidebar for desktop */}
        <div className="hidden md:fixed md:inset-y-0 md:flex md:w-64 md:flex-col">
          {/* Sidebar component, swap this element with another sidebar if you like */}
          <div className="flex flex-grow flex-col overflow-y-auto border-r border-gray-200 bg-white pt-5">
            <div
              style={{ cursor: "pointer" }}
              className="flex flex-shrink-0 items-center px-4"
            >
              <img
                className="h-12 w-auto"
                src="https://res.cloudinary.com/dfb584zgd/image/upload/v1673349294/SerpMaze/serpMaze_xtbebq.png"
                alt="SerpMaze"
                onClick={takeMeToTheDashboardPage}
              />
            </div>
            <div className="mt-5 flex flex-grow flex-col">
              <nav className="flex-1 space-y-1 px-2 pb-4">
                {navigation.map((item) => (
                  <a
                    key={item.name}
                    href={item.href}
                    className={classNames(
                      item.current
                        ? "bg-gray-100 text-gray-900"
                        : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
                      "group flex items-center px-2 py-2 text-sm font-medium rounded-md"
                    )}
                  >
                    <item.icon
                      className={classNames(
                        item.current
                          ? "text-gray-500"
                          : "text-gray-400 group-hover:text-gray-500",
                        "mr-3 flex-shrink-0 h-6 w-6"
                      )}
                      aria-hidden="true"
                    />
                    {item.name}
                  </a>
                ))}
                <div className="space-y-1 mt-5">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "initial",
                      justifyContent: "space-between",
                      alignItems: "end",
                    }}
                  >
                    <h3
                      className="px-3 text-sm font-medium text-gray-500"
                      id="projects-headline"
                    >
                      Tracked sites
                    </h3>
                    <button
                      type="button"
                      className="inline-flex items-center rounded-full border border-transparent bg-indigo-600 p-1 text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                      onClick={showModal1}
                      style={{ cursor: "pointer" }}
                    >
                      <PlusSmallIcon className="h-4 w-4" aria-hidden="true" />
                    </button>
                  </div>
                  <div
                    className="space-y-1"
                    role="group"
                    aria-labelledby="projects-headline"
                  >
                    {secondaryNavigation?.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="group flex items-center rounded-md px-3 py-2 text-sm font-medium text-gray-600 hover:bg-gray-50 hover:text-gray-900"
                      >
                        <span className="truncate">{item.name}</span>
                      </a>
                    ))}
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </div>
        <div className="flex flex-1 flex-col md:pl-64">
          <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 bg-white shadow">
            <button
              type="button"
              className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden"
              onClick={() => setSidebarOpen(true)}
            >
              <span className="sr-only">Open sidebar</span>
              <Bars3BottomLeftIcon className="h-6 w-6" aria-hidden="true" />
            </button>
            <div className="flex flex-1 justify-between px-4">
              <div className="flex flex-1">
                <form className="flex w-full md:ml-0" action="#" method="GET">
                  <label htmlFor="search-field" className="sr-only">
                    Search
                  </label>
                  <div className="relative w-full text-gray-400 focus-within:text-gray-600">
                    <span />
                  </div>
                </form>{" "}
              </div>
              <div className="ml-4 flex items-center md:ml-6">
                {/* Profile dropdown */}
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                      <span className="sr-only">Open user menu</span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        class="w-6 h-6"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </Menu.Button>
                  </div>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                      {userNavigation.map((item) => (
                        <Menu.Item key={item.name}>
                          {({ active }) => (
                            <a
                              onClick={avatarOnClickFunction}
                              href={item.href}
                              className={classNames(
                                active ? "bg-gray-100" : "",
                                "block px-4 py-2 text-sm text-gray-700"
                              )}
                            >
                              {item.name}
                            </a>
                          )}
                        </Menu.Item>
                      ))}
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>

          <main className="flex-1">
            <div className="">
              {/* /End replace */}
              {overallLoading === true ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <LoadingIndicator />
                </div>
              ) : overallLoadingWithWarningText === true ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <p style={{ fontWeight: "600" }}>
                    Please hang on. We are analysing your keywords.
                  </p>

                  <p style={{ fontWeight: "600" }}>
                    This can take up to a couple of minutes.
                  </p>
                  <LoadingIndicator />
                </div>
              ) : (
                <Content>
                  <section className="general-layout ant-layout">
                    <main className="general-layout-content ant-layout-content">
                      <div className="ant-card analysis-form-card ant-card-bordered">
                        {/* <div className="ant-card-body"></div> */}
                      </div>

                      <div className="outer-wrapper-for-body-content">
                        {newDataSourceForTheTable.length > 0 &&
                          firstTimeUser === false && (
                            <>
                              {isCustomerPaying === false ? (
                                <Alert
                                  message="Want to add more keywords?"
                                  /* showIcon */
                                  style={{ fontWeight: "500" }}
                                  description="Upgrade now to add more keywords. Just $7/mo."
                                  type="success"
                                  action={
                                    <Button
                                      size="small"
                                      danger
                                      onClick={navigateToPricesPageFunction}
                                    >
                                      Upgrade now
                                    </Button>
                                  }
                                />
                              ) : (
                                ""
                              )}

                              <div>
                                <div className="relative">
                                  <div
                                    className="absolute inset-0 flex items-center"
                                    aria-hidden="true"
                                  >
                                    <div className="w-full border-t border-gray-300" />
                                  </div>
                                  <div className="relative flex justify-center">
                                    <span
                                      style={{ backgroundColor: "#F0F2F5" }}
                                      className="px-3 text-base font-semibold leading-6 text-gray-900"
                                    >
                                      Summary
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="space-y-6 mb-6">
                                <div className="mt-3 grid grid-cols-2 md:grid-cols-3 gap-4">
                                  {stats.map((item) => (
                                    <div
                                      key={item.name}
                                      className="p-6 bg-white rounded-lg "
                                    >
                                      <div className="flex items-baseline justify-between">
                                        <dt className="font-normal font-medium text-gray-900 text-xs lg:text-lg lg:font-bold">
                                          {" "}
                                          {item.name}
                                        </dt>

                                        <div
                                          className={classNames(
                                            item.changeType === "increase"
                                              ? " text-green-800"
                                              : item.changeType === "decrease"
                                              ? " text-red-800"
                                              : "",
                                            "inline-flex items-baseline rounded-full px-2.5 py-0.5 text-sm font-medium"
                                          )}
                                        >
                                          {item.changeType === "increase" ? (
                                            <ArrowUpIcon
                                              className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-green-500"
                                              aria-hidden="true"
                                            />
                                          ) : item.changeType === "decrease" ? (
                                            <ArrowDownIcon
                                              className="-ml-1 mr-0.5 h-5 w-5 flex-shrink-0 self-center text-red-500"
                                              aria-hidden="true"
                                            />
                                          ) : null}
                                          <span className="sr-only">
                                            {item.changeType === "increase"
                                              ? "Increased"
                                              : item.changeType === "decrease"
                                              ? "Decreased"
                                              : ""}{" "}
                                            by {Math.abs(item.change)}
                                          </span>
                                          {item.change === 0 ? "" : item.change}
                                        </div>
                                      </div>

                                      <div className="mt-1 text-3xl font-semibold tracking-tight text-gray-900">
                                        {item.stat}
                                        <div className="w-full">
                                          <span className="text-xs font-medium text-gray-500">
                                            {item.name === "Improved Keywords"
                                              ? `since yesterday`
                                              : item.change === 0
                                              ? `also ${item.previousStat} yesterday`
                                              : item.previousStat !== null
                                              ? `from ${item.previousStat} yesterday`
                                              : ""}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              </div>
                            </>
                          )}
                        <div className="flex">
                          <div className="w-full">
                            {firstTimeUser === true ? (
                              <div className="outer-wrapper-for-body-content">
                                <div className="w-full">
                                  <div className="bg-white p-4 rounded-lg">
                                    <h2 className="text-lg font-semibold">
                                      Welcome to SerpMaze!
                                    </h2>
                                    <p className="text-sm">
                                      Let's start tracking some of your
                                      keywords. Go to the Dashboard page to
                                      start setting up your first page.
                                    </p>
                                    <div>
                                      <button
                                        className="bg-green-600 text-white py-2 px-4 rounded-lg"
                                        onClick={takeMeToTheDashboardPage}
                                        data-cy="add-new-tracked-website"
                                        type="button"
                                        style={{ fontWeight: "900" }}
                                      >
                                        Take me to the dashboard page
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : isCustomerPaying === true ? (
                              <>
                                <div className="bg-white p-4 mb-4 rounded-lg">
                                  <div className="flex-grow">
                                    <h2 className="text-lg font-semibold mb-4">
                                      Historic averages
                                    </h2>
                                  </div>
                                  <div className="button-container">
                                    {renderChartButtonsForAveragePositionCharts()}
                                    <button
                                      onClick={() =>
                                        setIsAveragePositionChartVisible(
                                          !isAveragePositionChartVisible
                                        )
                                      }
                                      className="toggle"
                                    >
                                      {isAveragePositionChartVisible
                                        ? "Hide Chart"
                                        : "Show Chart"}
                                    </button>
                                  </div>
                                  {isAveragePositionChartVisible && (
                                    <div className="chart-container mt-4">
                                      {renderChartForAveragePositionChart()}
                                    </div>
                                  )}
                                </div>

                                <div className="bg-white p-4 rounded-lg">
                                  <div className="flex flex-col lg:flex-row justify-between items-start">
                                    {/* Left Content - Keyword Overview and website */}
                                    <div className="flex-grow">
                                      <h2 className="text-lg font-semibold mb-2">
                                        Keyword Overview
                                      </h2>
                                      <p className="text-green-600 text-xl font-semibold">
                                        {usersWebsite}
                                      </p>
                                    </div>

                                    {/* Buttons Group */}
                                    <div className="flex flex-wrap gap-2 lg:w-128">
                                      {/* All buttons go here with the same width and height for uniformity */}

                                      <button
                                        type="button"
                                        onClick={showAddKeywordsModal}
                                        className="hover-effect-for-the-4-keyword-table-buttons w-full  lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900  ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                      >
                                        <ChevronRightIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Add keywords
                                      </button>

                                      {/* Add keywords button */}

                                      {/* Download csv button */}
                                      <button
                                        type="button"
                                        onClick={
                                          donwloadInformationAsCSVFunction
                                        }
                                        className="hover-effect-for-the-4-keyword-table-buttons w-full  lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900  ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                      >
                                        <ChevronRightIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Download csv
                                      </button>

                                      {/* Share custom report button */}

                                      {/* <button
                                        type="button"
                                        onClick={
                                          showTheChangeGoogleRegionsModalFunction
                                        }
                                        className="hover-effect-for-the-4-keyword-table-buttons w-full  lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900  ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                      >
                                        <ChevronRightIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Tracked region
                                      </button> */}
                                      <button
                                        type="button"
                                        onClick={handleModalOpen}
                                        className="hover-effect-for-the-4-keyword-table-buttons w-full lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                                      >
                                        <ChevronRightIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Share report
                                      </button>

                                      <button
                                        type="button"
                                        onClick={() =>
                                          setShowDeleteSiteModal(true)
                                        }
                                        className="hover-effect-for-the-4-keyword-table-buttons w-full lg:w-48 h-10 inline-flex items-center justify-center gap-x-1.5 rounded-md bg-white px-3.5 py-2.5 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-red-500 hover:bg-gray-50"
                                      >
                                        <ChevronRightIcon
                                          className="h-5 w-5"
                                          aria-hidden="true"
                                        />
                                        Remove site
                                      </button>
                                    </div>
                                  </div>

                                  <div className="flex flex-col mt-2 mb-2">
                                    <small>
                                      Keywords are updated once every 24 hours
                                      at 6am CET.
                                    </small>
                                    {Link && (
                                      <small className="mt-4">
                                        Unique sharable link:
                                        <a
                                          href={Link}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {Link.length > 25
                                            ? `${Link.substring(0, 30)}...`
                                            : Link}
                                        </a>
                                      </small>
                                    )}
                                  </div>

                                  {Array.isArray(newDataSourceForTheTable) &&
                                  newDataSourceForTheTable.length ? (
                                    <Table
                                      className="table-for-keyword-tracking-component"
                                      scroll={{ x: 500 }}
                                      pagination={{ pageSize: 15 }}
                                      dataSource={newDataSourceForTheTable}
                                      columns={columns}
                                      size="small"
                                      expandedRowRender={expandedRowRender}
                                      expandable={{
                                        expandedRowKeys: expandedRowKeys,
                                        onExpandedRowsChange: (
                                          newExpandedRowKeys
                                        ) => {
                                          // Find the new key that is not in the previous expandedRowKeys
                                          const newKey =
                                            newExpandedRowKeys.find(
                                              (key) =>
                                                !expandedRowKeys.includes(key)
                                            );

                                          // If there is a new key, find its corresponding record and trigger onRowClick
                                          if (newKey) {
                                            const record =
                                              newDataSourceForTheTable.find(
                                                (item) => item.key === newKey
                                              );
                                            if (record) {
                                              onRowClick(record);
                                            }
                                          } else {
                                            // If no new key is found, it means a row was collapsed
                                            setExpandedRowKeys([]);
                                          }
                                        },
                                        /*   expandIcon: ({
                                          expanded,
                                          onExpand,
                                          record,
                                        }) => {
                                          return (
                                            <a
                                              href={void 0}
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                onExpand(record, e);
                                              }}
                                              style={{
                                                display: "inline-block",
                                                fontWeight: "bold",
                                                border: "grey solid 1px",
                                                borderRadius: "5px",
                                                paddingRight: "4px",
                                                paddingLeft: "4px",
                                              }}
                                            >
                                              <span>
                                                {expanded ? "-" : "+"}
                                              </span>
                                            </a> */
                                        expandIcon: ({
                                          expanded,
                                          onExpand,
                                          record,
                                        }) => {
                                          return (
                                            <div
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                onExpand(record, e);
                                              }}
                                              className={
                                                expanded
                                                  ? "plusminus active"
                                                  : "plusminus"
                                              }
                                              style={{
                                                position: "relative",
                                                width: "15px",
                                                height: "15px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <div
                                                style={{
                                                  backgroundColor: "#333",
                                                  position: "absolute",
                                                  top: "50%",
                                                  left: "0",
                                                  transition: ".35s",
                                                  width: "100%",
                                                  height: "3px",
                                                  transform: expanded
                                                    ? "translateY(-50%) rotate(-90deg)"
                                                    : "translateY(-50%)",
                                                  opacity: expanded ? 0 : 1,
                                                }}
                                              ></div>
                                              <div
                                                style={{
                                                  backgroundColor: "#333",
                                                  position: "absolute",
                                                  top: "50%",
                                                  left: "0",
                                                  transition: ".35s",
                                                  width: "100%",
                                                  height: "3px",
                                                  transform: expanded
                                                    ? "translateY(-50%) rotate(0)"
                                                    : "translateY(-50%) rotate(90deg)",
                                                }}
                                              ></div>
                                            </div>
                                          );
                                        },
                                      }}
                                    />
                                  ) : (
                                    <div className="keywords-table">
                                      <Alert
                                        message="You haven't added any keywords to track yet."
                                        type="info"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#000",
                                          fontWeight: "400",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                                {/* <div className="mb-4 mt-3 ">
                                  <CustomAlert
                                    message={`You are tracking ${overallNumberOfKeywordsForAllSites} out of maximum 100 keywords for your website(s).`}
                                  />
                                </div> */}
                              </>
                            ) : (
                              <>
                                <div className="bg-white p-4 rounded-lg">
                                  <p className="text-sm">
                                    You are tracking{" "}
                                    {newDataSourceForTheTable.length} out of
                                    maximum 1 tracked keywords for your website.
                                    If you need more keywords, please consider
                                    upgrading to another plan.
                                  </p>
                                  <div className="flex">
                                    <div className="mr-4">
                                      <div
                                        className="text-sm cursor-pointer text-blue-600"
                                        onClick={
                                          showTheChangeGoogleRegionsModalFunction
                                        }
                                      >
                                        Tracked region{" "}
                                        <i className="fas fa-caret-right"></i>
                                      </div>
                                    </div>
                                    <div>
                                      <div
                                        className="text-sm cursor-pointer text-blue-600"
                                        onClick={showAddKeywordsModal}
                                      >
                                        Add keywords{" "}
                                        <i className="fas fa-plus-circle"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex mt-4">
                                    <div className="mr-4">
                                      <div
                                        className="text-sm cursor-pointer text-blue-600"
                                        onClick={
                                          donwloadInformationAsCSVFunction
                                        }
                                      >
                                        Download csv{" "}
                                        <i className="fas fa-caret-right"></i>
                                      </div>
                                    </div>
                                    <div>
                                      <div
                                        className="text-sm cursor-pointer text-blue-600"
                                        onClick={shareUniqueLinkFunction}
                                      >
                                        Share custom report{" "}
                                        <i className="fas fa-caret-right"></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="flex flex-col mt-4">
                                    <small>
                                      Keywords are updated once every 24 hours
                                      at 6am CET.
                                    </small>
                                  </div>
                                  {Array.isArray(newDataSourceForTheTable) &&
                                  newDataSourceForTheTable.length ? (
                                    <Table
                                      scroll={{ x: 500 }}
                                      pagination={{ pageSize: 15 }}
                                      dataSource={newDataSourceForTheTable}
                                      columns={columns}
                                      size="small"
                                    />
                                  ) : (
                                    <div className="keywords-table">
                                      <Alert
                                        message="You haven't added any keywords to track yet."
                                        type="info"
                                        style={{
                                          borderRadius: "4px",
                                          color: "#000",
                                          fontWeight: "400",
                                        }}
                                      />
                                    </div>
                                  )}
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </main>
                  </section>
                  {/* </div> */}
                  {/******** //BELOW IS THE MODAL FOR ADDING MORE KEYWORDS*********** */}
                  <Modal
                    title="Add keywords"
                    open={show}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form onSubmit={submitMoreKeywordsFunction}>
                      <div className="dashboard-modal-inner-box">
                        <div>
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Add your keywords:{" "}
                            <span style={{ fontWeight: "900" }}>
                              {" "}
                              (Please add one keyword per line)
                            </span>
                            <p>
                              You have{" "}
                              <span style={{ fontWeight: "900" }}>
                                {numKeywordsLeft}
                              </span>{" "}
                              keywords left.
                            </p>
                            {/* THIS IS THE ERROR MESSAGE IN CASE THE USER HAS ADDED TOO MANY KEYWORDS */}
                            {numKeywordsLeft < 0 && (
                              <span style={{ color: "red" }}>
                                SORRY: You have exceeded the maximum number of
                                keywords allowed for your subscription. Please
                                consider upgrading.
                              </span>
                            )}
                          </label>
                          <div className="mt-1">
                            <textarea
                              rows={4}
                              style={{
                                /* background: "#e0dbdb", */
                                border: "solid green 1px",
                                fontSize: "16px",
                                padding: "0.5em",
                                spellCheck: "false",
                                autocomplete: "off",
                                autocorrect: "off",
                                autocapitalize: "off",
                              }}
                              spellcheck="false"
                              autocomplete="off"
                              autocorrect="off"
                              autocapitalize="off"
                              name="comment"
                              id="comment"
                              className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                              defaultValue={""}
                              placeholder="Add your keywords"
                              onChange={onChangeForTheAddingOfMoreKeywords}
                            />
                          </div>
                        </div>
                        {Array.isArray(addedKeywordsFromModal) &&
                        addedKeywordsFromModal?.length > 0 &&
                        addedKeywordsFromModal[0]?.length > 0 &&
                        loading === false ? (
                          <div>
                            <Button
                              style={{
                                marginBottom: "24px",
                                marginTop: "24px",
                              }}
                              className="dashboard-modal-button"
                              variant="success"
                              type="submit"
                              disabled={numKeywordsLeft < 0}
                            >
                              <p className="dashboard-modal-button-text">
                                Add keywords
                              </p>
                            </Button>
                          </div>
                        ) : loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <LoadingIndicator />
                          </div>
                        ) : addedKeywordsFromModal[0]?.length === 0 ? (
                          <Button
                            style={{
                              marginBottom: "24px",
                              marginTop: "24px",
                            }}
                            className="dashboard-modal-button"
                            variant="success"
                            type="submit"
                            disabled="true"
                          >
                            <p className="dashboard-modal-button-text">
                              Add keywords
                            </p>
                          </Button>
                        ) : (
                          <Button
                            style={{
                              marginBottom: "24px",
                              marginTop: "24px",
                            }}
                            className="dashboard-modal-button"
                            variant="success"
                            type="submit"
                            disabled="true"
                          >
                            <p className="dashboard-modal-button-text">
                              Add keywords
                            </p>
                          </Button>
                        )}
                      </div>
                    </Form>
                  </Modal>
                  {/* **************END OF MODAL*************** */}

                  {/* BELOW IS THE SHARE UNIQUE LINK MODAL */}

                  <Modal
                    title="Choose what columns to share"
                    open={visibleTheUniQueLinkModal}
                    onOk={handleOkForUniqueLinkModal}
                    onCancel={handleCancelForUniqueLinkModal}
                    footer={[
                      <Button
                        key={uuidv4()}
                        type="primary"
                        onClick={handleOkForUniqueLinkModal}
                      >
                        Submit
                      </Button>,
                    ]}
                    className="dashboard-edit-add-modal-outer-box"
                    maskStyle={{ backgroundColor: "transparent" }} // not making the background of the body grey
                  >
                    {" "}
                    <Form onSubmit={handleOkForUniqueLinkModal}>
                      <div className="dashboard-modal-inner-box">
                        <div>
                          <label
                            htmlFor="comment"
                            className="block text-sm font-medium text-gray-700"
                          >
                            Choose the columns you would like to share:
                          </label>
                          <div className="mt-1">
                            <Checkbox.Group value={selectedColumns}>
                              {columns.map((column, index) => {
                                if (
                                  column.key === "action" ||
                                  column.key === "update" ||
                                  column.key === "trend"
                                ) {
                                  return null;
                                }
                                return (
                                  <div key={`${column.key}-${index}`}>
                                    <Checkbox
                                      value={column.dataIndex}
                                      disabled={column.dataIndex === "keyword"}
                                      onChange={(e) =>
                                        handleCheckboxChange(
                                          column.dataIndex,
                                          e.target.checked
                                        )
                                      }
                                    >
                                      {column.specialLabel ? (
                                        <span>
                                          <b
                                            style={{
                                              textTransform: "capitalize",
                                            }}
                                          >
                                            {column.dataIndex}
                                          </b>{" "}
                                          ({column.specialLabel})
                                        </span>
                                      ) : (
                                        column.dataIndex
                                      )}
                                    </Checkbox>
                                    {column.dataIndex === "keyword" && (
                                      <span className="ml-4">
                                        <Tooltip
                                          title={`Show top ${topKeywords} keywords only`}
                                        >
                                          <InfoCircleOutlined />
                                        </Tooltip>
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </Checkbox.Group>
                          </div>
                        </div>
                        <div style={{ marginTop: "1em" }}>
                          <label
                            htmlFor="topKeywords"
                            className="block text-sm font-medium text-gray-700"
                            style={{ marginRight: "8px" }}
                          >
                            What keywords would you like to include:
                          </label>
                          <div>
                            <Radio.Group
                              value={topKeywords}
                              onChange={(e) => setTopKeywords(e.target.value)}
                            >
                              <div>
                                <Radio value={0}>
                                  <b>All keywords</b>
                                </Radio>
                              </div>
                              <div>
                                <Radio value={3}>
                                  <b>Top 3</b> keywords only
                                </Radio>
                              </div>
                              <div>
                                <Radio value={10}>
                                  <b>Top 10</b> keywords only
                                </Radio>
                              </div>
                              <div>
                                <Radio value={30}>
                                  <b>Top 30</b> keywords only
                                </Radio>
                              </div>
                            </Radio.Group>
                          </div>
                        </div>
                        <Button
                          style={{ marginBottom: "24px", marginTop: "24px" }}
                          className="dashboard-modal-button"
                          variant="success"
                          type="submit"
                        >
                          <p className="dashboard-modal-button-text">
                            Create unique link now
                          </p>
                        </Button>
                      </div>
                    </Form>
                  </Modal>

                  {/******** //BELOW IS THE MODAL CHANGING GOOGLE REGION*********** */}
                  <Modal
                    title="Location and primary device"
                    open={showChangeGoogleRegionModal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form
                      onSubmit={handleSubmitForChangingGoogleRegionAndDevice}
                    >
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          Your current target location and device:
                        </p>
                        <p>
                          Location:
                          <span style={{ fontWeight: "700", color: "green" }}>
                            {country}
                          </span>
                        </p>
                        <p>
                          Device:{" "}
                          <span style={{ fontWeight: "700", color: "green" }}>
                            {device}
                          </span>
                        </p>
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                            textDecoration: "underline",
                          }}
                        >
                          You can change your input below:
                        </p>
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          Location
                        </p>
                        <p>
                          Please enter the new location of your primary target
                          audience.
                        </p>

                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <Select
                            placeholder="Search..."
                            styles={customStylesWhenNotDisabled}
                            options={options}
                            value={selectedGoogleDomain}
                            onChange={onChangeForGoogleRegion}
                          />
                        </Form.Group>
                        <Form.Group controlId="exampleForm.ControlSelect1">
                          <p
                            style={{
                              fontWeight: "600",
                              fontSize: "15px",
                            }}
                          >
                            Primary device
                          </p>
                          <p>
                            Please enter the new primary device you would like
                            to track your keyword via.
                          </p>

                          <Select
                            placeholder="Select..."
                            options={deviceOptions}
                            value={device?.device}
                            onChange={onChangeOfDeviceHandler}
                            styles={customStyles}
                          />
                        </Form.Group>
                        {errorInFetching === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Sorry, something went wrong. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again later.
                            </small>
                          </div>
                        )}
                      </div>
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <form
                          onSubmit={
                            handleSubmitForChangingGoogleRegionAndDevice
                          }
                        >
                          {loading === true ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <LoadingIndicator />
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              {deviceChosen === true &&
                              googleRegionsChosen === true ? (
                                <Button
                                  style={{ marginBottom: "24px" }}
                                  className="dashboard-modal-button"
                                  variant="success"
                                  type="submit"
                                  onClick={
                                    handleSubmitForChangingGoogleRegionAndDevice
                                  }
                                >
                                  <p className="dashboard-modal-button-text">
                                    Change now
                                  </p>
                                </Button>
                              ) : (
                                <Button
                                  style={{ marginBottom: "24px" }}
                                  className="dashboard-modal-button"
                                  variant="secondary"
                                  type="submit"
                                  onClick={
                                    handleSubmitForChangingGoogleRegionAndDevice
                                  }
                                  disabled="true"
                                >
                                  <p className="dashboard-modal-button-text">
                                    Change now
                                  </p>
                                </Button>
                              )}
                            </div>
                          )}
                        </form>
                      </div>
                    </Form>
                  </Modal>
                  {/* **************END OF MODAL*************** */}

                  {/* MODAL FOR DELETING MULTIPLE ROWS */}
                  <Modal
                    title="Are you sure you would like to delete the selected keywords?"
                    visible={showMultiDeleteModal}
                    onCancel={() => setShowMultiDeleteModal(false)}
                    footer={null} // Removes the default footer
                    className="modal-detete-button-outer-container"
                  >
                    <div
                      className="modal-delete-button-inner-container"
                      style={{ flexDirection: "row", padding: "24px" }}
                    >
                      <Button
                        style={{ width: "100%", marginRight: "12px" }}
                        className="modal-delete-button-no-button"
                        onClick={() => setShowMultiDeleteModal(false)}
                      >
                        No
                      </Button>
                      <Button
                        style={{ width: "100%", marginLeft: "12px" }}
                        className="modal-delete-button-yes-button"
                        onClick={deleteMultipleRowsInTableFunction}
                      >
                        Yes
                      </Button>
                    </div>
                  </Modal>

                  {/* //BELOW IS THE MODAL FOR SHOWING THE TOP DOMAINS FOR A KEYWORD *************************** */}
                  <Modal
                    title={`Top domains for: ${keywordSelected}`}
                    open={showTop100Modal}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="modal-top-100-domains-outer-container"
                    maskStyle={{ backgroundColor: "transparent" }}
                  >
                    {dataAvailableForTop100Modal ? (
                      <Table
                        scroll={{ x: 500 }}
                        pagination={{ pageSize: 15 }}
                        dataSource={top100Data}
                        columns={columnsForTheTop100Table}
                      />
                    ) : (
                      <p
                        style={{
                          textAlign: "center",
                          margin: "20px 20px",
                          paddingBottom: "20px",
                        }}
                      >
                        No Data Available
                      </p>
                    )}
                  </Modal>

                  {/* //BELOW IS THE MODAL THAT SHOWS UP IF A NON-PAYING USER IS TRYING TO ADD MORE THAN 3 KEYWORDS  *************************** */}

                  <Modal
                    title={`Please upgrade first`}
                    open={numberOfKeywordsExceeded}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <div className="dashboard-modal-inner-box">
                      <Form.Group controlId="exampleForm.ControlTextarea1">
                        <Form.Text
                          className="please-note-text"
                          style={{
                            color: "black",
                            marginTop: "-1em",
                            maxWidth: "372px",
                          }}
                        >
                          You can only track{" "}
                          <span style={{ fontWeight: "900" }}>1</span> keyword
                          on the free plan.<br></br> Please consider upgrading
                          to track more keywords.<br></br>
                          <span style={{ fontWeight: "900" }}>
                            You can test the paid plan 14 days for free.
                          </span>
                        </Form.Text>{" "}
                      </Form.Group>

                      <Button
                        style={{ marginBottom: "24px" }}
                        className="dashboard-modal-button"
                        variant="success"
                        onClick={navigateToPricesPageFunction}
                      >
                        <p className="dashboard-modal-button-text">
                          Upgrade now
                        </p>
                      </Button>
                    </div>
                  </Modal>

                  {/* //BELOW IS THE MODAL THAT SHOWS UP IF A PAYING-USER IS TRYING TO ADD MORE THAN 100 KEYWORDS  *************************** */}

                  <Modal
                    title={`You have reached the limit`}
                    open={numberOfKeywordsExceededForPayingUser}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    footer={[]}
                    className="dashboard-edit-add-modal-outer-box"
                  >
                    <Form /* onSubmit={navigateToPricesPageFunction} */>
                      <div className="dashboard-modal-inner-box">
                        <Form.Group controlId="exampleForm.ControlTextarea1">
                          <Form.Text
                            className="please-note-text"
                            style={{
                              color: "black",
                              marginTop: "-1em",
                              maxWidth: "372px",
                            }}
                          >
                            You can only track{" "}
                            <span style={{ fontWeight: "900" }}>100</span>{" "}
                            keywords on the paid plan. If you would like to
                            track more keywords then please write us on
                            contact@serpmaze.com
                          </Form.Text>{" "}
                        </Form.Group>
                      </div>
                    </Form>
                  </Modal>

                  {/* MODAL 1. BELOW DOR ADDING AN ADDITIONAL WEBSITE! */}
                  <Modal
                    title="Add a new website"
                    open={isModal1Open}
                    onOk={showModal2}
                    onCancel={handleCancelModals}
                    footer={[
                      /* THIS FIRST BUTTON IS NOT BEING USED AND IS HIDDING USING CSS */
                      {
                        /* <Button key="back" */
                      } /* onClick={handleCancel} */ >
                        {
                          /*    Return
                                </Button>,

                                <Button
                                  key="submit"
                                  type="primary"
                                  
                                  onClick={showModal2}
                                >
                                  Next
                                </Button>, */
                        },
                    ]}
                  >
                    <div>
                      <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                        <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">1</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Website
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="ant-steps-item ant-steps-item-wait">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">2</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Location
                              </div>
                            </div>
                          </div>
                        </div>
                        {/*  <div className="ant-steps-item ant-steps-item-wait">
                                    <div className="ant-steps-item-container">
                                      <div className="ant-steps-item-tail"></div>
                                      <div className="ant-steps-item-icon">
                                        <span className="ant-steps-icon">
                                          3
                                        </span>
                                      </div>
                                      <div className="ant-steps-item-content">
                                        <div className="ant-steps-item-title">
                                          Competitors
                                        </div>
                                      </div>
                                    </div>
                                  </div> */}
                        <div className="ant-steps-item ant-steps-item-wait">
                          <div className="ant-steps-item-container">
                            <div className="ant-steps-item-tail"></div>
                            <div className="ant-steps-item-icon">
                              <span className="ant-steps-icon">3</span>
                            </div>
                            <div className="ant-steps-item-content">
                              <div className="ant-steps-item-title">
                                Keywords
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-card-body modal-input-field-and-text-underneath">
                        <form onSubmit={handleSubmitForModal1}>
                          <Input
                            style={{
                              borderRadius: "4px",
                              fontSize: "16px",
                              spellCheck: "false",
                              autocomplete: "off",
                              autocorrect: "off",
                              autocapitalize: "off",
                            }}
                            spellcheck="false"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            size="large"
                            placeholder="example: bbc.com"
                            prefix={<GlobalOutlined />}
                            onChange={onChangeFunctionForUrlInput}
                            value={domainNameEntered}
                            className="input-field-modal-1"
                          />
                          <small>
                            Please note: You do not need to add http(s) or
                            "www."
                          </small>

                          {urlDoesNotExist === true && (
                            <div>
                              <small style={{ color: "red" }}>
                                Url does not exist. Are you sure you typed
                                everything correctly?
                              </small>
                              <br></br>
                              <small style={{ color: "red" }}>
                                Please try again.
                              </small>
                            </div>
                          )}

                          {errorInFetching === true && (
                            <div>
                              <small style={{ color: "red" }}>
                                Sorry, something went wrong. 🙁
                              </small>
                              <br></br>
                              <small style={{ color: "red" }}>
                                Please try again later.
                              </small>
                            </div>
                          )}

                          <div
                            style={{
                              textAlign: "end",
                            }}
                          >
                            {showModalNextButton === true &&
                            /* loading === false && */
                            domainNameEntered.length >= 4 &&
                            !domainNameEntered.includes("@") &&
                            !domainNameEntered.includes("!") ? (
                              <Button
                                key="submit1"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal1}
                              >
                                Next
                              </Button>
                            ) : loading === true ? (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <LoadingIndicator />
                              </div>
                            ) : (
                              <Button
                                style={{
                                  background: "grey",
                                  border: "none",
                                }}
                                key="submit2"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal1}
                                disabled={true}
                              >
                                Next
                              </Button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </Modal>
                  {/* MODAL 2. BELOW IS THE SECOND MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 1 */}
                  <Modal
                    title="Add a new website"
                    open={isModal2Open}
                    onOk={handleOkModal}
                    onCancel={handleCancelModals}
                    footer={[]}
                  >
                    <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Website</div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">2</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Location</div>
                          </div>
                        </div>
                      </div>
                      {/* <div className="ant-steps-item ant-steps-item-wait">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">3</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Competitors
                                      </div>
                                    </div>
                                  </div>
                                </div> */}
                      <div className="ant-steps-item ant-steps-item-wait">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">3</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Keywords</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                      >
                        Your target location
                      </p>
                      <p>
                        Please enter the location of your primary target
                        audience.
                      </p>

                      <Form.Group controlId="exampleForm.ControlSelect1">
                        <Select
                          placeholder="Search..."
                          styles={customStylesWhenNotDisabled}
                          options={options}
                          value={selectedGoogleDomain}
                          onChange={onChangeForGoogleRegion}
                        />
                      </Form.Group>
                      <Form.Group controlId="exampleForm.ControlSelect1">
                        <p
                          style={{
                            fontWeight: "600",
                            fontSize: "15px",
                          }}
                        >
                          Primary device
                        </p>
                        <p>
                          Please enter the primary device you would like to
                          track your keywords ranking via.
                        </p>

                        <Select
                          placeholder="Select..."
                          options={deviceOptions}
                          value={device?.device}
                          onChange={onChangeOfDeviceHandler}
                          styles={customStyles}
                        />
                      </Form.Group>
                      {errorInFetching === true && (
                        <div>
                          <small style={{ color: "red" }}>
                            Sorry, something went wrong. 🙁
                          </small>
                          <br></br>
                          <small style={{ color: "red" }}>
                            Please try again later.
                          </small>
                        </div>
                      )}
                    </div>
                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <form onSubmit={handleSubmitForModal2}>
                        {loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                            }}
                          >
                            <div>
                              <LoadingIndicator />
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              style={{
                                background: "grey",
                                border: "none",
                                marginRight: "8px",
                              }}
                              key="submit3"
                              /* loading={loading} */

                              onClick={(e) => {
                                e.preventDefault();
                                showModal1();
                              }}
                            >
                              Back
                            </Button>
                            {deviceChosen === true &&
                            googleRegionsChosen === true ? (
                              <Button
                                style={{ marginLeft: "8px" }}
                                key="submit4"
                                type="primary"
                                /* loading={loading} */
                                onClick={handleSubmitForModal2}
                              >
                                Next
                              </Button>
                            ) : (
                              <Button
                                style={{
                                  background: "grey",
                                  border: "none",
                                  marginLeft: "8px",
                                }}
                                key="submit5"
                                type="primary"
                                /* loading={loading} */
                                onClick={showModal4}
                                disabled={true}
                              >
                                Next
                              </Button>
                            )}
                          </div>
                        )}
                      </form>
                    </div>
                  </Modal>
                  {/* MODAL 3. BELOW IS THE THIRD MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 2 */}
                  {/* MODAL 3 WILL BE ADDED LATER!!! */}
                  {/*  <Modal
                              title="Add a competitor"
                              open={isModal3Open}
                              onOk={handleOk}
                              onCancel={handleCancel}
                              footer={[]}
                            >
                              <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                                <div className="ant-steps-item ant-steps-item-finish">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">
                                        <i
                                          aria-label="icon: check"
                                          className="anticon anticon-check ant-steps-finish-icon"
                                        >
                                          <CheckOutlined />
                                        </i>
                                      </span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Website
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-finish">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">
                                        <i
                                          aria-label="icon: check"
                                          className="anticon anticon-check ant-steps-finish-icon"
                                        >
                                          <CheckOutlined />
                                        </i>
                                      </span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Location
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">3</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Competitors
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="ant-steps-item ant-steps-item-wait">
                                  <div className="ant-steps-item-container">
                                    <div className="ant-steps-item-tail"></div>
                                    <div className="ant-steps-item-icon">
                                      <span className="ant-steps-icon">4</span>
                                    </div>
                                    <div className="ant-steps-item-content">
                                      <div className="ant-steps-item-title">
                                        Keywords
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="ant-card-body modal-input-field-and-text-underneath">
                                <p
                                  style={{
                                    fontWeight: "600",
                                    fontSize: "15px",
                                  }}
                                >
                                  Add a competitor of {domainNameEntered}
                                </p>
                                <p>
                                  To compare your SEO with one of your
                                  competitors you can add a competitors url.{" "}
                                </p>
                                <p>
                                  If you don't want to add a competitor right
                                  now - just leave the field blank.
                                </p>
                                <Input
                                  style={{ borderRadius: "4px" }}
                                  size="large"
                                  placeholder="example: competitor.com"
                                  prefix={<GlobalOutlined />}
                                  onChange={onChangeFunctionForCompetitorInput}
                                  value={competitorFromInput}
                                  className="input-field-modal-1"
                                />
                                <small>
                                  Please note: You do not need to add http(s) or
                                  "www."
                                </small>

                                {competitorDoesNotExist === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      URL does not exist. Are you sure you typed
                                      everything correctly?
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Please try again.
                                    </small>
                                  </div>
                                )}

                                {errorInFetching === true && (
                                  <div>
                                    <small style={{ color: "red" }}>
                                      Sorry, something went wrong. 🙁
                                    </small>
                                    <br></br>
                                    <small style={{ color: "red" }}>
                                      Please try again later.
                                    </small>
                                  </div>
                                )}
                              </div>
                              <div className="ant-card-body modal-input-field-and-text-underneath">
                                <form onSubmit={handleSubmitForModal3}>
                                  {loading === true ? (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                      }}
                                    >
                                      <Loading />
                                    </div>
                                  ) : (
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <Button
                                        style={{
                                          background: "grey",
                                          border: "none",
                                          marginRight: "8px",
                                        }}
                                        key="submit6"
                                        type="primary"
                                        
                                        onClick={showModal2}
                                      >
                                        Back
                                      </Button>

                                      <Button
                                        key="submit7"
                                        type="primary"
                                        
                                        onClick={handleSubmitForModal3}
                                      >
                                        Next
                                      </Button>
                                    </div>
                                  )}
                                </form>
                              </div>
                            </Modal> */}
                  {/* MODAL 4. BELOW IS THE FOURTH MODAL WHEN CLICKING THE "NEXT" BUTTON FROM MODAL 3 */}
                  <Modal
                    title="Add your keywords"
                    open={isModal4Open}
                    onOk={handleOkModal}
                    onCancel={handleCancelModals}
                    footer={[]}
                  >
                    <div className="ant-steps ant-steps-horizontal ant-steps-label-horizontal">
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Website</div>
                          </div>
                        </div>
                      </div>
                      <div className="ant-steps-item ant-steps-item-finish">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">
                              <i
                                aria-label="icon: check"
                                className="anticon anticon-check ant-steps-finish-icon"
                              >
                                <CheckOutlined />
                              </i>
                            </span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Location</div>
                          </div>
                        </div>
                      </div>

                      <div className="ant-steps-item ant-steps-item-process ant-steps-item-active">
                        <div className="ant-steps-item-container">
                          <div className="ant-steps-item-tail"></div>
                          <div className="ant-steps-item-icon">
                            <span className="ant-steps-icon">3</span>
                          </div>
                          <div className="ant-steps-item-content">
                            <div className="ant-steps-item-title">Keywords</div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <p
                        style={{
                          fontWeight: "600",
                          fontSize: "15px",
                        }}
                      >
                        Add keywords for {domainNameEntered}
                      </p>
                      <p>
                        {payingUser === true ? (
                          <span>
                            Add up to{" "}
                            <span style={{ fontWeight: "900" }}>
                              {subscriptionType}
                            </span>{" "}
                            keywords to track.
                          </span>
                        ) : (
                          <span>
                            You are currently on the free plan, so you can only
                            add <span style={{ fontWeight: "900" }}>1</span>{" "}
                            keyword to track.
                          </span>
                        )}
                        <p>
                          You have{" "}
                          <span style={{ fontWeight: "900" }}>
                            {numKeywordsLeft}
                          </span>{" "}
                          keywords left.
                        </p>
                      </p>
                      {numKeywordsLeft < 0 && (
                        <span style={{ color: "red" }}>
                          Sorry: You have exceeded the maximum number of
                          keywords allowed for your subscription.
                        </span>
                      )}
                      <div>
                        <label
                          htmlFor="comment"
                          className="block text-sm font-medium text-gray-700"
                        >
                          <span style={{ fontWeight: "900" }}>
                            {" "}
                            (Please add one keyword per line)
                          </span>
                        </label>
                        <div className="mt-1">
                          <textarea
                            rows={4}
                            style={{
                              border: "solid green 1px",
                              fontSize: "16px",
                              padding: "0.5em",
                              spellCheck: "false",
                              autocomplete: "off",
                              autocorrect: "off",
                              autocapitalize: "off",
                            }}
                            spellcheck="false"
                            autocomplete="off"
                            autocorrect="off"
                            autocapitalize="off"
                            name="comment"
                            id="comment"
                            className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
                            defaultValue={""}
                            placeholder="Add your keywords"
                            onChange={onChangeForModal4InputField}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="ant-card-body modal-input-field-and-text-underneath">
                      <form onSubmit={setupAllInformationAfterModal4Function}>
                        {errorInFetching === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Sorry, something went wrong. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again later.
                            </small>
                          </div>
                        )}

                        {browserTimedOut === true && (
                          <div>
                            <small style={{ color: "red" }}>
                              Hmmmmm, {domainNameEntered} timed out. 🙁
                            </small>
                            <br></br>
                            <small style={{ color: "red" }}>
                              Please try again.
                            </small>
                          </div>
                        )}

                        {loading === true ? (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              marginTop: "1em",
                            }}
                          >
                            <div>
                              <small style={{ color: "green" }}>
                                We are on it. Give us a couple of seconds.🏃‍♀️
                              </small>
                              <br></br>
                            </div>
                            <div>
                              <LoadingIndicator />
                            </div>
                          </div>
                        ) : (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              style={{
                                background: "grey",
                                border: "none",
                                marginRight: "8px",
                              }}
                              key="submit8"
                              /* loading={loading} */
                              onClick={(e) => {
                                e.preventDefault();
                                showModal2();
                              }}
                            >
                              Back
                            </Button>

                            <Button
                              key="submit9"
                              type="primary"
                              /* loading={loading} */
                              disabled={
                                numKeywordsLeft < 0 ||
                                (addedKeywordsFromModal?.length || 0) === 0
                              }
                              onClick={setupAllInformationAfterModal4Function}
                            >
                              Finish setup
                            </Button>
                          </div>
                        )}
                      </form>
                    </div>
                  </Modal>

                  <Modal
                    title="Are you sure?"
                    open={showDeleteSiteModal}
                    onOk={handleYesClick}
                    onCancel={handleNoClick}
                    footer={[]}
                    className="modal-detete-button-outer-container"
                  >
                    <div
                      className="modal-delete-button-inner-container"
                      style={{
                        flexDirection: "row",
                        padding: "24px",
                      }}
                    >
                      <Button
                        style={{
                          width: "100%",
                          marginRigth: "12px",
                          backgroundColor: "#6c757d",
                          borderRadius: "0.25rem",
                          color: "white",
                          fontWeight: "400",
                          border: "none",
                          height: "2.8em",
                          fontSize: "1rem",
                        }}
                        className="modal-delete-button-no-button"
                        variant="secondary"
                        onClick={handleNoClick}
                      >
                        No
                      </Button>
                      <Button
                        style={{
                          width: "100%",
                          fontSize: "1rem",
                          marginLeft: "12px",
                          backgroundColor: "#4aac48",
                          borderRadius: "0.25rem",
                          color: "white",
                          fontWeight: "400",
                          border: "none",
                          height: "2.8em",
                        }}
                        className="modal-delete-button-yes-button"
                        variant="success"
                        onClick={handleYesClick}
                      >
                        Yes
                      </Button>
                    </div>
                  </Modal>
                </Content>
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
}
